<template>
  <v-content>
    <template v-if="maintain">
      <div class="d-flex justify-center align-center">
        <span style="font-size: 50px;color: #ff6d81">{{ pageMessage }}</span>
      </div>
    </template>
    <template v-else>
      <v-container>
        <v-card>
          <v-card-title>

          </v-card-title>
          <v-card-text>
            <v-list-item>
              <v-spacer></v-spacer>
              <v-text-field label="ค้นหา" v-model="search"></v-text-field>
            </v-list-item>
            <v-list-item class="justify-center">
              <v-radio-group row v-model="MeetFilter" @change="ChangeTypeMeeting">
                <v-radio class="font-weight-bold" label="ทั้งหมด" value="0"></v-radio>
                <v-radio class="font-weight-bold" label="งานที่กำลังดำเนินการ" value="1"></v-radio>
                <v-radio class="font-weight-bold" label="งานที่รอดำเนินการ" value="2"></v-radio>
              </v-radio-group>
            </v-list-item>
            <v-data-table :headers="HeaderMeeting" :items="MeetingDataDump" :search="search">
              <template v-slot:item.Topic_Custom="{ item }">
                <div v-html="item.Topic_Custom"></div>
              </template>
              <template v-slot:item.action="{ item }">
                <div>
                  <v-btn text color="#00BCD4" @click="RegisterMeeting(item)" class="text--darken-4">
                    REGISTER เข้าร่วมประชุม
                  </v-btn>
                </div>
                <div>
                  <v-btn :loading="item.IsLoading" :disabled="item.IsLoading" text color="green"
                    class="text&#45;&#45;darken-4" v-if="!item.IsExport" @click="fetchJoinMeetData(item)">
                    EXPORT รายชื่อ
                  </v-btn>
                  <template v-else>
                    <download-excel class="btn btn-default" :data="json_data" :fields="json_fields" worksheet="รายชื่อ"
                      :title="array_title" :footer="array_footer"
                      :name="'รายชื่อผู้เข้าร่วมงาน ' + item.Topic + '.xls'">
                      <v-btn text color="pink" class="text&#45;&#45;darken-4" @click="ExportEmpData2(item)">
                        ดาวน์โหลดรายชื่อ (บุคลากร) (xlsx)
                      </v-btn>
                    </download-excel>
                    <!--                    <download-excel-->
                    <!--                        class="btn btn-default"-->
                    <!--                        :data="json_data"-->
                    <!--                        :fields="json_fields"-->
                    <!--                        worksheet="รายชื่อ"-->
                    <!--                        :title="array_title"-->
                    <!--                        :footer="array_footer"-->
                    <!--                        :name="'รายชื่อผู้เข้าร่วมงาน ' + item.Topic + '.xls'"-->
                    <!--                    >-->
                    <!--                      <v-btn text color="pink" class="text&#45;&#45;darken-4" @click="ExportData2(item)">-->
                    <v-btn text color="pink" class="text&#45;&#45;darken-4" @click="ExportPdfData(item, true, true)">
                      ดาวน์โหลดรายชื่อ (ผู้ลงทะเบียนเข้าร่วม) (ใหม่)
                    </v-btn>
                    <div>
                      <v-btn text color="pink" class="text&#45;&#45;darken-4" @click="ExportPdfData(item, true, false)">
                        ดาวน์โหลดรายชื่อ (ทั้งหมด) (ใหม่)
                      </v-btn>
                    </div>
                    <div>
                      <v-btn text color="pink" class="text&#45;&#45;darken-4"
                        @click="ExportPdfData(item, false, false)">
                        ดาวน์โหลดรายชื่อ (สำเนา)
                      </v-btn>
                    </div>
                    <!--                    </download-excel>-->
                  </template>
                </div>
                <!--              <div>
                                <v-btn text color="yellow" @click="EditMeeting(item)" class="text&#45;&#45;darken-4">
                                  แก้ไขข้อมูล
                                </v-btn>
                                <v-btn text color="red" @click="DelMeeting(item)" class="text&#45;&#45;darken-4">
                                  ลบ
                                </v-btn>
                                <div>
                                  <v-btn
                                      :loading="item.IsLoading"
                                      :disabled="item.IsLoading"
                                      text
                                      color="green"
                                      class="text&#45;&#45;darken-4"
                                      v-if="!item.IsExport"
                                      @click="fetchJoinMeetData(item)"
                                  >
                                    EXPORT รายชื่อ
                                  </v-btn>
                                  <download-excel
                                      class="btn btn-default"
                                      :data="json_data"
                                      :fields="json_fields"
                                      worksheet="รายชื่อ"
                                      :title="array_title"
                                      :name="'รายชื่อผู้เข้าร่วมงาน ' + item.Topic + '.xls'"
                                      v-else
                                  >
                                    <v-btn text color="pink" class="text&#45;&#45;darken-4" @click="ExportData2(item)">
                                      ดาวน์โหลดรายชื่อ
                                    </v-btn>
                                  </download-excel>
                                </div>
                              </div>
                              <div>
                                <v-btn text color="blue" @click="GenerateLink(item)" class="text&#45;&#45;darken-4">
                                  สร้างลิงค์ใหม่
                                </v-btn>
                                <CopyToClipboard :text="item.url">
                                  <v-btn text color="blue" @click="Copy" class="text&#45;&#45;darken-1">
                                    คัดลอกลิงค์
                                  </v-btn>
                                </CopyToClipboard>
                              </div>-->
              </template>
            </v-data-table>
            <!--            <div v-html="html_data"></div>-->
          </v-card-text>
        </v-card>
      </v-container>
      <template>
        <v-dialog v-model="dialogReg" fullscreen hide-overlay transition="dialog-bottom-transition">
          <v-card>
            <v-toolbar dark color="primary">
              <v-btn icon dark @click="dialogReg = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-toolbar-title>ลงทะเบียนเข้าร่วมการประชุม</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn dark text @click="dialogReg = false" class="text-h4" style="background-color: red">
                  ปิด
                </v-btn>
              </v-toolbar-items>
            </v-toolbar>
            <v-list three-line subheader>
              <v-subheader>รายละเอียดข้อมูลการจัดประชุม</v-subheader>
              <v-list-item>
                <v-container>
                  <v-tabs v-model="tab" background-color="transparent" grow>
                    <v-tab key="DataJoinMeeting">
                      ข้อมูลผู้เข้าร่วมประชุม
                      <v-chip class="ml-2" color="green" dark>
                        <span v-if="Cordi_Count == '0'">
                          {{ this.JoinMeet.length }} / ไม่จำกัด
                        </span>
                        <span v-else>
                          {{ this.JoinMeet.length }} / {{ Count }}
                        </span>
                      </v-chip>
                    </v-tab>
                  </v-tabs>

                  <v-tabs-items v-model="tab">
                    <v-tab-item key="DataJoinMeeting">
                      <v-card>
                        <v-card-title>
                          <span class="font-weight-bold" v-if="MeetingObj != null">
                            ลงทะเบียนเข้าร่วมประชุม หัวข้อ : <span style="color: #364eff" class="text--darken-4">{{
                              (MeetingObj.Topic.replaceAll('&quot;', '"'))
                              }}</span>
                          </span>
                        </v-card-title>
                        <v-card-text>
                          <v-list>
                            <v-list-item>
                              <v-card style="width: 100%">
                                <v-card-text>
                                  <v-tabs v-model="joinTab" background-color="transparent" color="basil" show-arrows>
                                    <v-tabs-slider color="teal lighten-3"></v-tabs-slider>
                                    <v-tab>
                                      บุคลากรคณะแพทย์
                                    </v-tab>
                                    <template v-if="MeetingObj != null && MeetingObj.Limit_Reg_status == '1'">
                                      <v-tab>
                                        นักศึกษาคณะแพทย์
                                      </v-tab>
                                      <v-tab>
                                        บุคลากรคณะอื่น
                                      </v-tab>
                                      <v-tab>
                                        นักศึกษาคณะอื่น
                                      </v-tab>
                                      <v-tab>
                                        บุคคลภายนอก
                                      </v-tab>
                                      <v-tab>
                                        นักศึกษาภายนอก
                                      </v-tab>
                                    </template>
                                  </v-tabs>
                                  <v-tabs-items v-model="joinTab" class="mt-4">
                                    <v-tab-item>
                                      <v-card>
                                        <v-card-title>
                                          บุคลากร
                                        </v-card-title>
                                        <v-divider></v-divider>
                                        <v-card-text>
                                          <v-list-item class="justify-center">
                                            <v-radio-group row v-model="TypeReg">
                                              <v-radio class="font-weight-bold" label="สแกนบัตร, รหัสบุคลากร"
                                                value="0"></v-radio>
                                              <v-radio class="font-weight-bold"
                                                label="ชื่อ, รหัสบุคลากร, ภาควิชา/หน่วยงาน" value="1"
                                                color="green"></v-radio>
                                            </v-radio-group>
                                          </v-list-item>
                                          <v-list-item>
                                            <v-row class="d-flex justify-center">
                                              <v-col v-if="TypeReg == '0'" cols="12" md="6">
                                                <v-text-field v-model="staffSel" ref="staffSel"
                                                  label="สแกนบัตรบุคลากร"
                                                  hint="กด Enter หรือ คลิกปุ่ม ลงทะเบียน เพื่อเป็นการบันทึกข้อมูล"
                                                  persistent-hint clearable outlined :disabled="dialogLoading"
                                                  type="password" @keyup="checkKeyEnter2"></v-text-field>
                                              </v-col>
                                              <v-col v-else cols="12" md="6">
                                                <v-autocomplete v-model="staffSel" ref="staffSel" label="ค้นหาบุคลากร"
                                                  :items="staffData" item-text="customDetail" item-value="perid"
                                                  hint="กด Enter เพื่อเป็นการเพิ่มข้อมูล" persistent-hint clearable
                                                  outlined :disabled="dialogLoading"
                                                  @keyup="checkKeyEnter2"></v-autocomplete>
                                              </v-col>
                                              <v-col cols="12" md="2">
                                                <v-btn x-large class="darken-4" outlined color="primary"
                                                  :disabled="dialogLoading"
                                                  @click="MeetingObj.Limit_Reg_status == '0' ? RegisterPerson() : RegisterPersonUnlock()">
                                                  ลงทะเบียน
                                                </v-btn>
                                              </v-col>
                                            </v-row>
                                          </v-list-item>
                                        </v-card-text>
                                      </v-card>
                                    </v-tab-item>
                                    <v-tab-item>
                                      <v-card>
                                        <v-card-title>
                                          นักศึกษาคณะแพทย์
                                        </v-card-title>
                                        <v-divider></v-divider>
                                        <v-card-text>
                                          <v-list-item class="justify-center">
                                            <v-radio-group row v-model="TypeRegStd">
                                              <v-radio class="font-weight-bold" label="สแกนบัตร, รหัสนักศึกษา"
                                                value="0"></v-radio>
                                              <v-radio class="font-weight-bold" label="ชื่อ, รหัสนักศึกษา" value="1"
                                                color="green"></v-radio>
                                            </v-radio-group>
                                          </v-list-item>
                                          <template v-if="TypeRegStd == '0'">
                                            <v-row class="d-flex justify-center">
                                              <v-col class="d-flex justify-center" cols="12" md="6">
                                                <v-text-field v-model="staffSel" ref="staffSel" label="สแกนบัตรนักศึกษา"
                                                  persistent-hint clearable outlined :disabled="dialogLoading"
                                                  type="password" @keyup="checkKeyEnterStd2"></v-text-field>
                                              </v-col>
                                            </v-row>
                                          </template>
                                          <template v-else>
                                            <v-row class="d-flex justify-center">
                                              <v-col class="d-flex justify-center" cols="12" md="8">
                                                <v-autocomplete outlined :items="studentData" item-value="STUDENT_ID"
                                                  item-text="fullName" v-model="Idstudent"
                                                  label="ค้นหา ชื่อ - สกุล รหัสนักศึกษา" @keyup="checkKeyEnterStd"
                                                  ref="Idstudent">
                                                </v-autocomplete>
                                                <v-btn style="margin-left: 20px" color="primary" outlined x-large
                                                  @click="insertStd('med')">
                                                  ลงทะเบียน
                                                </v-btn>
                                              </v-col>
                                            </v-row>
                                          </template>

                                        </v-card-text>
                                      </v-card>
                                    </v-tab-item>
                                    <v-tab-item>
                                      <v-card>
                                        <v-card-title>
                                          บุคลากรคณะอื่น
                                        </v-card-title>
                                        <v-divider></v-divider>
                                        <v-card-text>
                                          <v-row class="d-flex justify-center">
                                            <v-col class="d-flex justify-center" cols="12" md="8">
                                              <v-autocomplete outlined :items="AllDepartData" item-value="FAC_ID"
                                                item-text="FAC_NAME_THAI" v-model="IdDepart" label="ค้นหาคณะ/สังกัด"
                                                @change="GetPersonalPSU">
                                              </v-autocomplete>
                                            </v-col>
                                          </v-row>
                                        </v-card-text>
                                        <v-card-text>
                                          <v-row class="d-flex justify-center">
                                            <v-col class="d-flex justify-center" cols="12" md="8">
                                              <v-autocomplete outlined :items="personalMedData" item-value="STAFF_ID"
                                                item-text="FULL_NAME" v-model="IdPersonal"
                                                label="ค้นหา ชื่อ - สกุล รหัสบุคลากร">
                                              </v-autocomplete>
                                              <v-btn x-large style="margin-left: 20px;" color="primary" outlined
                                                @click="insertPersonUni()">
                                                ลงทะเบียน
                                              </v-btn>
                                            </v-col>
                                          </v-row>
                                        </v-card-text>
                                      </v-card>
                                    </v-tab-item>
                                    <v-tab-item>
                                      <v-card>
                                        <v-card-title>
                                          นักศึกษาคณะอื่น
                                        </v-card-title>
                                        <v-divider></v-divider>
                                        <v-card-text>
                                          <v-row class="d-flex justify-center">
                                            <v-col class="d-flex justify-center" cols="12" md="8">
                                              <v-autocomplete outlined :items="AllDepartData" item-value="FAC_ID"
                                                item-text="FAC_NAME_THAI" v-model="IdDepartStd" label="ค้นหาคณะ"
                                                @change="GetStdPSU">
                                              </v-autocomplete>
                                            </v-col>
                                          </v-row>
                                        </v-card-text>
                                        <v-card-text>
                                          <v-row class="d-flex justify-center">
                                            <v-col class="d-flex justify-center" cols="12" md="8">
                                              <v-autocomplete outlined :items="studentUniData" item-value="STUDENT_ID"
                                                item-text="fullName" v-model="IdstudentUni" ref="IdstudentUni"
                                                label="ค้นหา ชื่อ - สกุล รหัสนักศึกษา"></v-autocomplete>
                                              <v-btn x-large style="margin-left: 20px;" color="primary" outlined
                                                @click="insertStd('other')">
                                                ลงทะเบียน
                                              </v-btn>
                                            </v-col>
                                          </v-row>
                                        </v-card-text>
                                      </v-card>
                                    </v-tab-item>
                                    <v-tab-item>
                                      <v-card>
                                        <v-card-title>
                                          บุคคลภายนอก
                                        </v-card-title>
                                        <v-divider></v-divider>
                                        <v-card-text>
                                          <v-row class="d-flex justify-center">
                                            <v-col cols="12" md="8">
                                              <v-row>
                                                <v-col cols="12" md="6">
                                                  <v-text-field v-model="NameP" label="ชื่อ (name)"
                                                    :error-messages="NameP == '' ? '*' : ''" :error="NameP == ''">
                                                  </v-text-field>
                                                </v-col>
                                                <v-col cols="12" md="6">
                                                  <v-text-field v-model="SurNameP" label="สกุล (surname)"
                                                    :error-messages="SurNameP == '' ? '*' : ''" :error="SurNameP == ''">
                                                  </v-text-field>
                                                </v-col>
                                              </v-row>
                                              <v-row>
                                                <v-col cols="12" md="4">
                                                  <v-text-field v-model="idCard" label="รหัสบัตรประชาชน">
                                                  </v-text-field>
                                                </v-col>
                                                <v-col cols="12" md="4">
                                                  <v-text-field v-model="affiliation" label="สังกัด">
                                                  </v-text-field>
                                                </v-col>
                                                <v-col cols="12" md="4">
                                                  <v-text-field v-model="position" label="ตำแหน่ง">
                                                  </v-text-field>
                                                </v-col>
                                              </v-row>
                                            </v-col>
                                          </v-row>
                                          <v-list-item>
                                            <v-row class="justify-center">
                                              <v-col cols="12" md="4">
                                                <v-text-field label="เบอร์โทร" v-model="phoneOther" text></v-text-field>
                                              </v-col>
                                            </v-row>
                                          </v-list-item>
                                          <v-list-item class="d-flex justify-center">
                                            <v-btn color="primary" outlined @click="insertDataPerson('person')">
                                              บันทึก
                                            </v-btn>
                                          </v-list-item>
                                        </v-card-text>
                                      </v-card>
                                    </v-tab-item>
                                    <v-tab-item>
                                      <v-card>
                                        <v-card-title>
                                          นักศึกษาภายนอก
                                        </v-card-title>
                                        <v-divider></v-divider>
                                        <v-card-text>
                                          <v-row class="d-flex justify-center">
                                            <v-col cols="12" md="8">
                                              <v-row>
                                                <v-col cols="12" md="6">
                                                  <v-text-field v-model="NameStd" label="ชื่อ (name)"
                                                    :error-messages="NameStd == '' ? '*' : ''" :error="NameStd == ''">
                                                  </v-text-field>
                                                </v-col>
                                                <v-col cols="12" md="6">
                                                  <v-text-field v-model="SurNameStd" label="สกุล (surname)"
                                                    :error-messages="SurNameStd == '' ? '*' : ''"
                                                    :error="SurNameStd == ''">
                                                  </v-text-field>
                                                </v-col>
                                              </v-row>
                                              <v-row>
                                                <v-col cols="12" md="6">
                                                  <v-text-field v-model="idCardStd" label="รหัสบัตรประชาชน">
                                                  </v-text-field>
                                                </v-col>
                                                <v-col cols="12" md="6">
                                                  <v-text-field v-model="affiliationStd" label="มหาวิทยาลัย">
                                                  </v-text-field>
                                                </v-col>
                                              </v-row>
                                            </v-col>
                                          </v-row>
                                          <v-list-item>
                                            <v-row class="justify-center">
                                              <v-col cols="12" md="4">
                                                <v-text-field label="เบอร์โทร" v-model="phoneOther" text></v-text-field>
                                              </v-col>
                                            </v-row>
                                          </v-list-item>
                                          <v-list-item class="d-flex justify-center">
                                            <v-btn color="primary" outlined @click="insertDataPerson('Std')">
                                              บันทึก
                                            </v-btn>
                                          </v-list-item>
                                        </v-card-text>
                                      </v-card>
                                    </v-tab-item>
                                  </v-tabs-items>
                                </v-card-text>
                              </v-card>
                            </v-list-item>
                            <div align="center" style="font-size: 20px;margin-top: 20px">
                              ผู้เข้าร่วมทั้งหมด {{ JoinMeet.length }} คน
                              ลงทะเบียน <span style="font-weight: bold;color: #42b983">{{
                                JoinMeet.filter(item => item.status_reg == '1').length
                              }}</span>
                              คน / รอลงทะเบียน <span style="font-weight: bold;color: red">{{
                                JoinMeet.filter(item => item.status_reg == '0').length
                              }}</span>
                              คน
                            </div>
                            <v-list-item>
                              <v-row class="d-flex justify-center">
                                <v-col class="d-flex justify-center" cols="12" md="6">
                                  <download-excel class="btn btn-default" :data="json_data" :fields="json_fields"
                                    worksheet="รายชื่อ" :title="array_title" :footer="array_footer"
                                    :name="'รายชื่อผู้เข้าร่วมงาน ' + MeetingObj.Topic + '.xls'"
                                    v-if="MeetingObj != null">
                                    <v-btn outlined color="green" class="darken-3" @click="ExportEmpData2(MeetingObj)">
                                      ดาวน์โหลดรายชื่อ (บุคลากร)
                                    </v-btn>
                                  </download-excel>
                                </v-col>
                                <v-col class="d-flex justify-center" cols="12" md="6">
                                  <!--                                  <download-excel-->
                                  <!--                                      class="btn btn-default"-->
                                  <!--                                      :data="json_data"-->
                                  <!--                                      :fields="json_fields_opt1"-->
                                  <!--                                      worksheet="รายชื่อ"-->
                                  <!--                                      :title="array_title"-->
                                  <!--                                      :footer="array_footer"-->
                                  <!--                                      :name="'รายชื่อผู้เข้าร่วมงาน ' + MeetingObj.Topic + '.xls'"-->
                                  <!--                                      v-if="MeetingObj != null"-->
                                  <!--                                  >-->
                                  <v-btn outlined color="green" class="darken-3"
                                    @click="ExportPdfData(MeetingObj, true, true)">
                                    ดาวน์โหลดรายชื่อ (ผู้ลงทะเบียนเข้าร่วม) (ใหม่)
                                  </v-btn>
                                  <!--                                  </download-excel>-->
                                </v-col>
                              </v-row>
                            </v-list-item>
                            <v-list-item>
                              <v-row class="d-flex justify-center">
                                <v-col class="d-flex justify-center" cols="12" md="6">
                                  <v-btn outlined color="green" class="darken-3"
                                    @click="ExportPdfData(MeetingObj, true, false)">
                                    ดาวน์โหลดรายชื่อ (ทั้งหมด) (ใหม่)
                                  </v-btn>
                                </v-col>
                                <v-col class="d-flex justify-center" cols="12" md="6">
                                  <v-btn outlined color="green" class="darken-3"
                                    @click="ExportPdfData(MeetingObj, false, false)">
                                    ดาวน์โหลดรายชื่อ (สำเนา)
                                  </v-btn>
                                </v-col>
                              </v-row>
                            </v-list-item>
                            <!--                            <div align="center">
                                                          <download-excel
                                                              class="btn btn-default"
                                                              :data="json_data"
                                                              :fields="json_fields"
                                                              worksheet="รายชื่อ"
                                                              :title="array_title"
                                                              :footer="array_footer"
                                                              :name="'รายชื่อผู้เข้าร่วมงาน ' + MeetingObj.Topic + '.xls'"
                                                              v-if="MeetingObj != null"
                                                          >
                                                            <v-btn outlined color="green" class="darken-3" @click="ExportData">
                                                              Export ข้อมูล
                                                            </v-btn>
                                                          </download-excel>
                                                        </div>-->
                            <v-list-item>
                              <v-spacer></v-spacer>
                              <v-text-field v-model="search2" label="ค้นหา"></v-text-field>
                            </v-list-item>
                            <v-list-item v-if="JoinMeet.length > 0">
                              <v-spacer></v-spacer>
                              <v-btn text color="green" @click="RegisterAll('1')">ลงทะเบียนทั้งหมด</v-btn>
                              <v-btn text color="red" @click="RegisterAll('0')">รอลงทะเบียนทั้งหมด</v-btn>
                            </v-list-item>
                            <v-list-item class="d-flex justify-center mt-6">
                              <v-data-table :search="search2" :headers="JoinMeetHeader" :items="JoinMeet">
                                <!--                              <template v-slot:item.action="{item}">
                                                                <v-btn color="red"
                                                                       @click="DelData(item.idx)"
                                                                       outlined
                                                                >
                                                                  ลบ
                                                                </v-btn>
                                                              </template>-->
                                <template v-slot:item.type="{ item }">
                                  <span v-if="item.registerType_id == '0'" style="color: #ff6d81">
                                    บุคลากรคณะแพทย์
                                  </span>
                                  <span v-if="item.registerType_id == '1'" style="color: #ff6d81">
                                    นักศึกษาคณะแพทย์
                                  </span>
                                  <span v-if="item.registerType_id == '2'" style="color: blue">
                                    บุคลากรคณะอื่น
                                  </span>
                                  <span v-if="item.registerType_id == '3'" style="color: blue">
                                    นักศึกษาคณะอื่น
                                  </span>
                                  <span v-if="item.registerType_id == '4'" style="color: darkslateblue">
                                    บุคคลภายนอก
                                  </span>
                                  <span v-if="item.registerType_id == '5'" style="color: darkslateblue">
                                    นักศึกษาภายนอก
                                  </span>
                                </template>
                                <template v-slot:item.status_reg="{ item }">
                                  <v-radio-group row v-model="item.status_reg" @change="RegisterPersonRdo(item)">
                                    <v-radio class="font-weight-bold" label="ลงทะเบียน" value="1"
                                      color="green"></v-radio>
                                    <v-radio class="font-weight-bold" label="รอลงทะเบียน" value="0"
                                      color="red"></v-radio>
                                  </v-radio-group>
                                </template>
                                <template v-slot:item.action="{ item }">
                                  <v-btn color="red" outlined @click="DelPerson(item)">ลบ</v-btn>
                                </template>
                              </v-data-table>
                            </v-list-item>
                          </v-list>
                        </v-card-text>
                      </v-card>
                    </v-tab-item>
                  </v-tabs-items>
                </v-container>
              </v-list-item>
            </v-list>
          </v-card>
        </v-dialog>
      </template>
      <v-dialog v-model="dialogLoading" persistent width="300">
        <v-card color="primary" dark>
          <v-card-text>
            Loading...
            <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogStdReg" persistent width="800">
        <v-card>
          <v-card-title>
            <span>
              กรอกรหัสนักศึกษาเพื่อทำการลงทะเบียน
            </span>
          </v-card-title>
          <v-card-text class="mt-8">
            <v-row class="d-flex justify-center">
              <v-col class="d-flex justify-center" cols="12" md="8">
                <v-autocomplete outlined :items="studentData" item-value="STUDENT_ID" item-text="fullName"
                  v-model="Idstudent" label="ค้นหา ชื่อ - สกุล รหัสนักศึกษา" @keyup="checkKeyEnterStd" ref="Idstudent">
                </v-autocomplete>
                <v-btn style="margin-left: 20px;" color="primary" x-large dark @click="insertStd('med')">
                  ลงทะเบียน
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click=" dialogStdReg = false" x-large color="red" dark>ปิด</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <template>
        <v-snackbar v-model="snackbar" :color="color">
          {{ text }}

          <template v-slot:action="{ attrs }">
            <v-btn color="red" text v-bind="attrs" @click="snackbar = false">
              Close
            </v-btn>
          </template>
        </v-snackbar>
      </template>
    </template>
    <template>
      <v-snackbar v-model="alertBar" :color="alertBarColor" :timeout="timeout">
        {{ alertBarText }}
        <template v-slot:actions>
          <v-btn color="blue" variant="text" @click="alertBar = false">
            Close
          </v-btn>
        </template>
      </v-snackbar>
    </template>
  </v-content>
</template>

<script>
import Vue from 'vue'
import { mapActions, mapGetters } from "vuex";
import axios from "axios";
import ConstData from "@/const/Const";
import Const from "@/const/Const";

var TinyURL = require('tinyurl');

export default {
  name: "ReggisterMeeting",
  data() {
    return {
      alertBarColor: 'pimary',
      alertBarText: '',
      timeout: 1000,
      alertBar: false,
      dialogStdReg: false,
      html_data: '',
      phoneOther: '',
      NameP: '',
      SurNameP: '',
      affiliation: '',
      position: '',
      idCard: '',
      NameStd: '',
      SurNameStd: '',
      affiliationStd: '',
      idCardStd: '',
      studentData: [],
      studentUniData: [],
      IdDepartStd: '',
      IdDepart: '',
      Idstudent: null,
      IdstudentUni: '',
      IdPersonal: '',
      personalMedData: [],
      AllDepartData: [],
      joinTab: null,
      pageMessage: 'ปิดปรับปรุงระบบชั่วคราว',
      CheckMeetigCordi: false,
      maintain: false,
      TypeReg: '0',
      TypeRegStd: '0',
      color: 'black',
      text: '',
      snackbar: false,
      codePermiss: '12001',
      CheckAdmin: false,
      CheckSubAdmin: false,
      MeetFilter: '0',
      loading: false,
      dialogLoading: false,
      array_title: [],
      array_footer: [],
      json_fields: {
        'ลำดับ': 'index',
        "รหัสบุคลากร": 'perid',
        "คำนำหน้า": 'iname',
        "ชื่อ": 'name',
        "นามสกุล": 'surname',
        "หน่วยงาน": 'dep_name',
        "กลุ่มหน่วยงาน": 'dep_group_name',
        "ตำแหน่ง": 'pos_name',
        "ศาสนา": 'religion_name',
        // "งบวิชาการตามสิทธิ์ที่ได้รับ": 'money_permiss',
        "หมายเหตุ": 'remark',
        // "ศาสนา": 'religion_name',
        // "งบวิชาการตามสิทธิ์ที่ได้รับ": 'money_permiss',
        // "หมายเหตุ": 'remark',
      },
      json_fields_opt1: {
        'ลำดับ': 'index',
        "รหัสบุคลากร": 'perid',
        "คำนำหน้า": 'iname',
        "ชื่อ": 'name',
        "นามสกุล": 'surname',
        "หน่วยงาน": 'dep_name_old',
        "กลุ่มหน่วยงาน": 'dep_group_name',
        "ตำแหน่ง": 'pos_name',
        "วัน-เวลา ลงทะเบียน": 'update_time',
        // "ศาสนา": 'religion_name',
        // "งบวิชาการตามสิทธิ์ที่ได้รับ": 'money_permiss',
        // "หมายเหตุ": 'remark',
      },
      json_data: [],
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],
      DelFileId: [],
      JoinDel: [],
      Openfile: ConstData.ConnectionHost + '/rest/files',
      MeetingObj: null,
      dialogEdit: false,
      dialogReg: false,
      search: '',
      search2: '',
      HeaderMeeting: [
        { text: 'หัวข้อประชุม', value: 'Topic_Custom' },
        { text: 'ทำรายการ', value: 'action' }
      ],
      MeetingDataDump: [],
      Rm: '', // ข้อมูลตัวแปรเก่าจาก ManageMeeting
      files: [],
      alert: false,
      txtAlert: [],
      FileMeeting: [],
      FileMeetingToDb: [],
      searchPerson: '',
      staffSel: '',
      card_no: '',
      tab: 'DataMeeting',
      Topic: '',
      Count: '0',
      Date_start: '',
      Date_reg_start: '',
      Date_end: '',
      Date_reg_end: '',
      Time_start: '',
      Time_end: '',
      DepSelect: '',
      Place: '',
      LinkGen: '',
      url: '',
      Cordi_Count: '0',
      Ref_id: '',
      headerAxios: {
        headers: {
          'Content-Type': 'application/json',
        }
      },
      headerAxiosPUT: {
        headers: {
          'X-REST-METHOD': 'PUT'
        }
      },
      headerAxiosDel: {
        headers: {
          'X-REST-METHOD': 'DELETE'
        }
      },
      JoinMeetHeader: [
        { text: 'รหัสอ้างอิง', value: 'uid' },
        { text: 'ชื่อ - สกุล', value: 'full_Name' },
        { text: 'สังกัด', value: 'affiliation' },
        { text: 'ประเภท', value: 'type' },
        { text: 'ลงทะเบียน', value: 'status_reg' },
        { text: '', value: 'action' }
      ],
      JoinMeet: [] // สิ้นสุดข้อมูลตัวแปรเก่าจาก ManageMeeting
    }
  },
  computed: {
    ...mapGetters({
      MeetingData: 'Meeting/getMeetingData',
      JoinMeetingData: 'Meeting/getJoinMeetingData',
      MeetingCordiData: 'Meeting/getMeetingCordiData',
      FilesData: 'Meeting/getFileData',
      MeData: 'Staff/getMeData',
      staffData: 'Staff/getStaff',
      CardData: 'Staff/getCard',
      CardData2: 'Staff/getCard2',
      depart: 'Depart/getDepart',
      Permission_Dep_User: 'Permission/getPermissionDepUser',
      Permission_Dep: 'Permission/getPermissionDep',
      PermissionAdmin: 'Permission/getPermission',
      Permission: 'Permission/getPermissionUser',
      MenuPermiss: 'Permission/getMenuPermiss',
      IgnoreMenuPermiss: 'Permission/getIgnoreMenuPermiss',
    })
  },
  methods: {
    ...mapActions({
      initMeData: 'Staff/initMeData',
      initMeetingData: 'Meeting/initMeetingData',
      initJoinMeetingData: 'Meeting/initJoinMeetingData',
      initMeetingCordiData: 'Meeting/initMeetingCordiData',
      initFileData: 'Meeting/initFileData',
      initDepartData: 'Depart/initDepartData',
      initStaffData: 'Staff/initStaffData',
      initCardData: 'Staff/initCardData',
      getExecCardData: 'Staff/getExecCardData',
      getCardDataMedStudent: 'Staff/getCardDataMedStudent',
      getPermissionDep: 'Permission/getPermissionDepData',
      getPermissionDepUserData: 'Permission/getPermissionDepUserData',
      getPermissionUserData: 'Permission/getPermissionUserData',
      getPermissionData: 'Permission/getPermissionData',
      getMenuPermissData: 'Permission/getMenuPermissData',
      getIgnoreMenuPermissData: 'Permission/getIgnoreMenuPermissData',
      changeColor: 'Page/changeColor',
      changeHeaderName: 'Page/changeHeaderName',
      changeTypeProject: 'Project/changeTypeProject',
    }),
    init() {
      /*this.sockets.subscribe('connect', (data) => {
        // console.log(data)
        this.text = data.description
        this.color = 'green'
        this.snackbar = true
      });
      this.sockets.subscribe('smc-error', (data) => {
        // console.log(data)
        this.text = 'พบข้อผิดพลาด (' + data.description + ')'
        this.color = 'red'
        this.snackbar = true
      });
      this.sockets.subscribe('smc-removed', (data) => {
        // console.log(data)
        this.text = 'การ์ดถูกถอด (' + data.description + ')'
        this.color = 'red'
        this.snackbar = true
      });
      this.sockets.subscribe('smc-incorrect', (data) => {
        // console.log(data)
        this.text = 'การอ่านข้อมูลไม่ถูกต้อง โปรดตรวจสอบ การใส่การ์ด หรือ ทำความสะอาดชิปบนการ์ดแล้วลองใหม่อีกครั้ง (' + data.description + ')'
        this.color = 'red'
        this.snackbar = true
      });
      this.sockets.subscribe('smc-inserted', (data) => {
        // console.log(data)
        this.text = 'การ์ดถูกใส่ (' + data.description + ')'
        this.color = 'black'
        this.snackbar = true
      });
      this.sockets.subscribe('smc-data', (data) => {
        this.text = 'อ่านข้อมูลสำเร็จ'
        this.color = 'green'
        this.snackbar = true
        if (data.status == 200) {
          var dataP = this.JoinMeet.filter(item => item.citizen_id == data.data.cid)
          if (dataP.length > 0) {
            this.RegisterPersonID_card(dataP[0])
          }
        }
      });*/

      this.dialogLoading = true
      this.MeetingDataDump = []
      this.MeetingDataOld = []
      this.MeetFilter = '0'
      var MeetingDump = []
      this.initMeetingCordiData()
      this.initCardData()
      this.initMeetingData().then(res => {
        if (res) {
          if (this.MeetingData.length > 0) {
            this.MeetingData.map(item => {
              MeetingDump.push({
                ...item,
                Topic_Custom: (item.Reg_status == '1') ? '<span style="font-weight: bold;color: #364eff;font-size: 15px">เรื่อง : ' + item.Topic + '</span>' +
                  '<div><span style="font-weight: bold;color: #42b983">วันที่ลงทะเบียน : ' + (item.Date_start == item.Date_end ? Vue.filter('DateToThai')(item.Date_reg_start) : Vue.filter('DateToThai')(item.Date_reg_start) + ' - ' + Vue.filter('DateToThai')(item.Date_reg_end)) + '</span></div>' +
                  '<div><span style="font-weight: bold;color: black">วันที่จัดงาน : ' + (item.Date_start == item.Date_end ? Vue.filter('DateToThai')(item.Date_start) : Vue.filter('DateToThai')(item.Date_start) + ' - ' + Vue.filter('DateToThai')(item.Date_end)) + '</span></div>' +
                  '<div><span style="font-weight: bold;color: black">เวลา : ' + item.Time_start + ' น. - ' + item.Time_end + ' น.' + '</span></div>' +
                  '<div><span style="font-weight: bold;color: black">สถานที่ : ' + item.Place + '</span></div>' +
                  '<div><span style="font-weight: bold;color: black">จำกัดผู้เข้าร่วม : ' + (item.Count_cordi == '0' ? 'ไม่จำกัด' : item.Count + ' คน') + '</span></div>' +
                  '<div><span style="font-weight: bold;color: #ff6d81">' + item.dep_name + '</span></div>' :
                  '<span style="font-weight: bold;color: #364eff;font-size: 15px">เรื่อง : ' + item.Topic + '</span>' +
                  '<div><span style="font-weight: bold;color: red">ปิดลงทะเบียน</span></div>' +
                  '<div><span style="font-weight: bold;color: black">วันที่จัดงาน : ' + (item.Date_start == item.Date_end ? Vue.filter('DateToThai')(item.Date_start) : Vue.filter('DateToThai')(item.Date_start) + ' - ' + Vue.filter('DateToThai')(item.Date_end)) + '</span></div>' +
                  '<div><span style="font-weight: bold;color: black">เวลา : ' + item.Time_start + ' น. - ' + item.Time_end + ' น.' + '</span></div>' +
                  '<div><span style="font-weight: bold;color: black">สถานที่ : ' + item.Place + '</span></div>' +
                  '<div><span style="font-weight: bold;color: black">จำกัดผู้เข้าร่วม : ' + (item.Count_cordi == '0' ? 'ไม่จำกัด' : item.Count + ' คน') + '</span></div>' +
                  '<div><span style="font-weight: bold;color: #ff6d81">' + item.dep_name + '</span></div>',
                IsLoading: false,
                IsExport: false,
              })
            })
          }

          if (this.CheckAdmin) {
            this.getPermissionDep({
              perid: this.MeData[0].perid
            }).then(resDep => {
              if (resDep) {
                if (MeetingDump.length > 0) {
                  if (this.Permission_Dep.length > 0) {
                    this.Permission_Dep.map(Dep => {
                      MeetingDump.map(meet => {
                        if (meet.dep_id == Dep.dep_id) {
                          this.MeetingDataDump.unshift({
                            ...meet
                          })
                        }
                      })
                    })
                  }
                }

                this.dialogLoading = false
              } else {
                this.dialogLoading = false
              }
            })
          } else if (this.CheckSubAdmin) {
            this.getPermissionDepUserData({
              perid: this.MeData[0].perid
            }).then(resDep => {
              if (resDep) {
                if (MeetingDump.length > 0) {
                  if (this.Permission_Dep_User.length > 0) {
                    this.Permission_Dep_User.map(Dep => {
                      MeetingDump.map(meet => {
                        if (meet.dep_id == Dep.dep_id) {
                          this.MeetingDataDump.unshift({
                            ...meet
                          })
                        }
                      })
                    })
                  }
                }

                this.dialogLoading = false
              } else {
                this.dialogLoading = false
              }
            })
          }
        }
      }).catch(res => {
        if (res) {
          this.dialogLoading = false
        }
      })
      axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/stdMed/STUDENT/FAC_ID/09/STUDY_STATUS/OK/?limit=99999').then(res => {
        if (res.data) {
          if (res.data.length > 0) {
            res.data.map(item => {
              this.studentData.push({
                ...item,
                fullName: 'รหัสนักศึกษา : ' + item.STUDENT_ID + ' ชื่อ-สกุล ' + item.STUD_NAME_THAI + ' ' + item.STUD_SNAME_THAI
              })
            })
          } else {
            this.studentData.push({
              ...res.data,
              fullName: 'รหัสนักศึกษา : ' + res.data[0].STUDENT_ID + ' ชื่อ-สกุล ' + res.data[0].STUD_NAME_THAI + ' ' + res.data[0].STUD_SNAME_THAI
            })
          }
        } else {
          this.studentData = []
        }
      })

      axios.get(ConstData.ConnectionHost + '/rest/v1/AllPersonal/dss_person.W_FACULTY/1').then(res => {
        if (res.data) {
          if (res.data.length > 0) {
            this.AllDepartData = res.data
          } else {
            this.AllDepartData.push(res.data)
          }
        } else {
          this.AllDepartData = []
        }
      })
    },
    GetStdPSU() {
      this.studentUniData = []
      axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/stdMed/STUDENT2_view/FAC_ID/' + this.IdDepartStd + '/?sort=STUDENT_ID_ASC&limit=99999').then(res => {
        if (res.data) {
          if (res.data.length > 0) {
            res.data.map(item => {
              this.studentUniData.push({
                ...item,
                fullName: 'รหัสนักศึกษา : ' + item.STUDENT_ID + ' ชื่อ-สกุล ' + item.STUD_NAME_THAI + ' ' + item.STUD_SNAME_THAI
              })
            })
          } else {
            this.studentUniData.push({
              ...res.data,
              fullName: 'รหัสนักศึกษา : ' + res.data[0].STUDENT_ID + ' ชื่อ-สกุล ' + res.data[0].STUD_NAME_THAI + ' ' + res.data[0].STUD_SNAME_THAI
            })
          }
        } else {
          this.studentUniData = []
        }
      })
    },
    GetPersonalPSU() {
      axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrstd/V_STAFF/FAC_ID/' + this.IdDepart + '/?sort=STAFF_ID_ASC&limit=99999').then(res => {
        if (res.data) {
          if (res.data.length > 0) {
            res.data.map(item => {
              this.personalMedData.push({
                ...item,
                FULL_NAME: '(' + item.STAFF_ID + ') ' + item.STAFF_NAME_THAI + ' ' + item.STAFF_SNAME_THAI
              })
            })
          } else {
            this.personalMedData.push(res.data)
          }
        } else {
          this.personalMedData = []
        }
      })
    },
    CheckPermission() {
      return new Promise(resolve => {
        var CheckPermiss = false
        if (this.PermissionAdmin.length > 0) {
          this.PermissionAdmin.map((Per_i, idx) => {
            if (Per_i.permission_id == this.codePermiss) {
              resolve(true)
            } else {
              if (!CheckPermiss && idx == this.PermissionAdmin.length - 1) {
                resolve(false)
              }
            }
          })
        } else {
          this.Permission.map((Per_i, idx) => {
            if (Per_i.permission_id == this.codePermiss) {
              resolve(true)
            } else {
              if (!CheckPermiss && idx == this.Permission.length - 1) {
                resolve(false)
              }
            }
          })
        }
      })
    },
    DelPerson(item) {
      this.$swal.fire({
        title: 'ยืนยันการทำรายการ',
        text: "คุณต้องการลบข้อมูลการประชุม คุณ " + item.full_Name + ' ใช่หรือไม่ ??',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.value) {
          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_meeting_join2/id/' + item.id, {
            active: '0',
            update_by: this.MeData[0].perid,
          }, this.headerAxios).then(resDel => {
            if (resDel.data.status) {
              if (item.status_reg == '1') {
                if (parseInt(item.registerType_id) == 0) {
                  axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/History_Experts/perid/' + item.uid + '/D_meeting_id/' + this.MeetingObj.id, {
                    active: '0',
                    update_by: this.MeData[0].perid,
                  }, this.headerAxios).then(resDel2 => {
                    if (resDel2.data.status) {
                      this.fetchJoinMeetData2()
                      this.$swal.fire({
                        icon: 'success',
                        title: 'ลบผู้เข้าประชุมรหัสอ้างอิง ' + item.uid + ' : ' + item.full_Name + ' สำเร็จ !!',
                        showConfirmButton: false,
                        timer: 700
                      })
                      // this.alertBarColor = 'error'
                      // this.alertBarText = 'ลบผู้เข้าประชุมรหัสอ้างอิง ' + item.uid + ' : ' + item.full_Name + ' สำเร็จ !!'
                      // this.alertBar = true
                    } else {
                      this.$swal.fire({
                        icon: 'error',
                        title: 'พบข้อผิดพลาดไม่สามารถลบรายชื่อได้',
                        showConfirmButton: false,
                        timer: 700
                      })
                      // this.$swal.fire({
                      //   icon: 'error',
                      //   title: 'พบข้อผิดพลาดไม่สามารถลบรายชื่อได้',
                      //   showConfirmButton: true,
                      // })
                      // this.alertBarColor = 'error'
                      // this.alertBarText = 'พบข้อผิดพลาดไม่สามารถลบรายชื่อได้'
                      // this.alertBar = true
                    }
                  })
                } else {
                  this.fetchJoinMeetData2()
                  this.$swal.fire({
                    icon: 'success',
                    title: 'ลบผู้เข้าประชุมรหัสอ้างอิง ' + item.uid + ' : ' + item.full_Name + ' สำเร็จ !!',
                    showConfirmButton: false,
                    timer: 700
                  })
                  // this.alertBarColor = 'error'
                  // this.alertBarText = 'ลบผู้เข้าประชุมรหัสอ้างอิง ' + item.uid + ' : ' + item.full_Name + ' สำเร็จ !!'
                  // this.alertBar = true
                }
              } else {
                this.fetchJoinMeetData2()
                this.$swal.fire({
                  icon: 'success',
                  title: 'ลบผู้เข้าประชุมรหัสอ้างอิง ' + item.uid + ' : ' + item.full_Name + ' สำเร็จ !!',
                  showConfirmButton: false,
                  timer: 700
                })
                // this.alertBarColor = 'error'
                // this.alertBarText = 'ลบผู้เข้าประชุมรหัสอ้างอิง ' + item.uid + ' : ' + item.full_Name + ' สำเร็จ !!'
                // this.alertBar = true
              }
            } else {
              this.$swal.fire({
                icon: 'error',
                title: 'พบข้อผิดพลาดไม่สามารถลบรายชื่อได้',
                showConfirmButton: false,
                timer: 700
              })
              // this.alertBarColor = 'error'
              // this.alertBarText = 'พบข้อผิดพลาดไม่สามารถลบรายชื่อได้'
              // this.alertBar = true
            }
          })
        }
      })
    },
    formatDateNow() {
      var d = new Date(),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2)
        month = '0' + month;
      if (day.length < 2)
        day = '0' + day;

      return [year, month, day].join('-');
    },
    ChangeTypeMeeting() {
      if (this.MeetingDataOld.length == 0) {
        this.MeetingDataOld = this.MeetingDataDump
      }
      switch (this.MeetFilter) {
        case "0":
          this.MeetingDataDump = this.MeetingDataOld
          break
        case "1":
          this.MeetingDataDump = this.MeetingDataOld.filter(item => item.Date_start <= this.formatDateNow() && item.Date_end >= this.formatDateNow())

          break
        case "2":
          this.MeetingDataDump = this.MeetingDataOld.filter(item => item.Date_start > this.formatDateNow())
          break
        default:
          break
      }
    },
    ExportDataOpt1() {
      this.json_data = []
      this.array_title = []
      this.array_footer = []
      this.array_title.push(this.Topic)
      // this.array_title.push('วันที่ ' + Vue.filter('DateToThai')(this.Date_start) + ' ถึง ' + Vue.filter('DateToThai')(this.Date_end))
      // this.array_title.push('สถานที่ ' + this.Place)
      if (this.Date_start == this.Date_end) {
        this.array_title.push('วันที่ ' + Vue.filter('DateToThai')(this.Date_start) + ' เวลา ' + this.Time_start + ' น. - ' + this.Time_end + ' น.')
      } else {
        this.array_title.push('วันที่ ' + Vue.filter('DateToThai')(this.Date_start) + ' ถึง ' + Vue.filter('DateToThai')(this.Date_end) + ' เวลา ' + this.Time_start + ' น. - ' + this.Time_end + ' น.')
      }
      this.array_title.push('สถานที่ ' + this.Place)
      this.array_footer.push([])
      this.array_footer.push([])
      this.array_footer.push('ขอรับรองว่าได้เตรียมอาหาร ให้แก่ผู้เข้าร่วมอบรมจริง จำนวน ' + this.JoinMeet.filter(item => item.status_reg == '1').length + ' คน โดยผ่านระบบอิเลคทรอนิกส์ ไม่ได้ลงลายมือชื่อ')
      if (this.JoinMeet.length > 0) {
        var JoinMeetDump = this.JoinMeet.filter(item => item.status_reg == '1')
        if (JoinMeetDump.length > 0) {
          JoinMeetDump = JoinMeetDump.sort((a, b) => new Date(a.update_time) - new Date(b.update_time));
          JoinMeetDump.map((item, idx) => {
            if (parseInt(item.salary) > 20000) {
              this.json_data.push({
                ...item,
                index: idx + 1,
                money_permiss: '15500'
              })
            } else {
              this.json_data.push({
                ...item,
                index: idx + 1,
                money_permiss: '11000'
              })
            }
          })
        } else {
          this.$swal.fire({
            icon: 'error',
            title: 'ไม่สามารถ Export ได้เนื่องจากโครงการที่เลือกไม่พบรายชื่อผู้ลงทะเบียนเข้าร่วมประชุม'
          })
        }
      }
    },
    ExportData() {
      this.json_data = []
      this.array_title = []
      this.array_footer = []
      this.array_title.push(this.Topic)
      // this.array_title.push('วันที่ ' + Vue.filter('DateToThai')(this.Date_start) + ' ถึง ' + Vue.filter('DateToThai')(this.Date_end))
      // this.array_title.push('สถานที่ ' + this.Place)
      if (this.Date_start == this.Date_end) {
        this.array_title.push('วันที่ ' + Vue.filter('DateToThai')(this.Date_start) + ' เวลา ' + this.Time_start + ' น. - ' + this.Time_end + ' น.')
      } else {
        this.array_title.push('วันที่ ' + Vue.filter('DateToThai')(this.Date_start) + ' ถึง ' + Vue.filter('DateToThai')(this.Date_end) + ' เวลา ' + this.Time_start + ' น. - ' + this.Time_end + ' น.')
      }
      this.array_title.push('สถานที่ ' + this.Place)
      this.array_footer.push([])
      this.array_footer.push([])
      this.array_footer.push('ขอรับรองว่าได้เตรียมอาหาร ให้แก่ผู้เข้าร่วมอบรมจริง จำนวน ' + this.JoinMeet.filter(item => item.status_reg == '1').length + ' คน โดยผ่านระบบอิเลคทรอนิกส์ ไม่ได้ลงลายมือชื่อ')
      if (this.JoinMeet.length > 0) {
        var JoinMeetDump = this.JoinMeet.filter(item => item.status_reg == '1')
        if (JoinMeetDump.length > 0) {
          JoinMeetDump = JoinMeetDump.sort((a, b) => a.dep_id.localeCompare(b.dep_id));
          JoinMeetDump.map((item, idx) => {
            if (parseInt(item.salary) > 20000) {
              this.json_data.push({
                ...item,
                index: idx + 1,
                money_permiss: '15500'
              })
            } else {
              this.json_data.push({
                ...item,
                index: idx + 1,
                money_permiss: '11000'
              })
            }
          })
        } else {
          this.$swal.fire({
            icon: 'error',
            title: 'ไม่สามารถ Export ได้เนื่องจากโครงการที่เลือกไม่พบรายชื่อผู้ลงทะเบียนเข้าร่วมประชุม'
          })
        }
      }
    },
    GenerateLink(item) {
      this.CheckPermission().then(res => {
        if (res) {
          // this.LinkGen = this.$uuid.v1()
          this.GenerateUrl(item).then(res => {
            axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_meeting/id/' + item.id, {
              url: res,
              update_by: this.MeData[0].perid,
            }, this.headerAxios).then(res => {
              if (res.data.status) {
                this.$swal.fire({
                  icon: 'success',
                  title: 'สร้าง Short Url การประชุม ' + item.Topic + ' ใหม่สำเร็จ'
                })
                this.init()
              } else {
                this.$swal.fire({
                  icon: 'error',
                  title: 'พบข้อผิดพลาดไม่สามารถสร้าง Short Url ได้!!'
                })
              }
            })
          })
        } else {
          this.$swal.fire({
            icon: 'error',
            title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
          })
        }
      })
    },
    async fetchJoinMeetData(item) {
      item.IsLoading = true
      await this.initJoinMeetingData({
        uuid: item.uuid,
        permiss_check: this.MeData[0].perid
      }).then(res => {
        if (res) {
          this.JoinMeet = this.JoinMeetingData
          this.JoinMeet.map((item, idx) => {
            item.idx = idx + 1
            item.IsDb = true
            item.full_Name = item.name + ' ' + item.sname
            item.idCard = item.id_card
          })
          item.IsLoading = false
          item.IsExport = true
        }
      }).catch(res => {
        if (res) {
          item.IsLoading = false
          this.$swal.fire({
            icon: 'error',
            title: 'ไม่พบข้อมูลรายชื่อผู้เข้าร่วมประชุม'
          })
        }
      })
    },
    ExportEmpData2(item) {
      this.json_data = []
      this.array_title = []
      this.array_footer = []
      var staff = []
      this.array_title.push(item.Topic)
      if (item.Date_start == item.Date_end) {
        this.array_title.push('วันที่ ' + Vue.filter('DateToThai')(item.Date_start) + ' เวลา ' + item.Time_start + ' น. - ' + item.Time_end + ' น.')
      } else {
        this.array_title.push('วันที่ ' + Vue.filter('DateToThai')(item.Date_start) + ' ถึง ' + Vue.filter('DateToThai')(item.Date_end) + ' เวลา ' + item.Time_start + ' น. - ' + item.Time_end + ' น.')
      }
      this.array_title.push('สถานที่ ' + item.Place)
      this.array_footer.push([])
      this.array_footer.push([])
      if (this.JoinMeet.length > 0) {
        var JoinMeetDump = this.JoinMeet
        if (JoinMeetDump.length > 0) {
          JoinMeetDump.map(itemJ => {
            staff = this.staffData.filter(value => value.perid == itemJ.uid)
            if (staff.length > 0) {
              if (parseInt(staff[0].salary) > 20000) {
                this.json_data.push({
                  ...itemJ,
                  iname: staff[0].iname,
                  perid: staff[0].perid,
                  surname: staff[0].surname,
                  dep_id: staff[0].dep_id,
                  dep_group_name: staff[0].dep_group_name,
                  dep_name: staff[0].dep_name,
                  pos_name: staff[0].pos_name,
                  religion_name: staff[0].religion_name,
                  remark: '',
                  index: this.json_data.length + 1,
                  money_permiss: '15500',
                })
              } else {
                this.json_data.push({
                  ...itemJ,
                  iname: staff[0].iname,
                  perid: staff[0].perid,
                  surname: staff[0].surname,
                  dep_id: staff[0].dep_id,
                  dep_group_id: staff[0].dep_group_id,
                  dep_name: staff[0].dep_name,
                  pos_name: staff[0].pos_name,
                  religion_name: staff[0].religion_name,
                  remark: '',
                  index: this.json_data.length + 1,
                  money_permiss: '11000'
                })
              }
            }
          })
          this.array_footer.push('ขอรับรองว่าได้เตรียมอาหาร ให้แก่ผู้เข้าร่วมอบรมจริง จำนวน ' + this.json_data.filter(itemJ => itemJ.status_reg == '1').length + ' คน โดยผ่านระบบอิเลคทรอนิกส์ ไม่ได้ลงลายมือชื่อ')
        } else {
          this.$swal.fire({
            icon: 'error',
            title: 'ไม่สามารถ Export ได้เนื่องจากโครงการที่เลือกไม่พบรายชื่อผู้ลงทะเบียนเข้าร่วมประชุม'
          })
        }
        // this.json_data = this.json_data.sort((a, b) => a.dep_id.localeCompare(b.dep_id));
      } else {
        this.$swal.fire({
          icon: 'error',
          title: 'ไม่สามารถ Export ได้เนื่องจากโครงการที่เลือกไม่พบรายชื่อผู้ลงทะเบียนเข้าร่วมประชุม'
        })
      }
      setTimeout(() => {
        item.IsExport = false
      }, 1000)
    },
    ExportData2(item) {
      this.json_data = []
      this.array_title = []
      this.array_footer = []
      this.array_title.push(item.Topic)
      if (item.Date_start == item.Date_end) {
        this.array_title.push('วันที่ ' + Vue.filter('DateToThai')(item.Date_start) + ' เวลา ' + item.Time_start + ' น. - ' + item.Time_end + ' น.')
      } else {
        this.array_title.push('วันที่ ' + Vue.filter('DateToThai')(item.Date_start) + ' ถึง ' + Vue.filter('DateToThai')(item.Date_end) + ' เวลา ' + item.Time_start + ' น. - ' + item.Time_end + ' น.')
      }
      this.array_title.push('สถานที่ ' + item.Place)
      this.array_footer.push([])
      this.array_footer.push([])
      this.array_footer.push('ขอรับรองว่าได้เตรียมอาหาร ให้แก่ผู้เข้าร่วมอบรมจริง จำนวน ' + this.JoinMeet.filter(itemJ => itemJ.status_reg == '1').length + ' คน โดยผ่านระบบอิเลคทรอนิกส์ ไม่ได้ลงลายมือชื่อ')
      if (this.JoinMeet.length > 0) {
        var JoinMeetDump = this.JoinMeet.filter(item => item.status_reg == '1')
        if (JoinMeetDump.length > 0) {
          // JoinMeetDump = JoinMeetDump.sort((a, b) => a.dep_id.localeCompare(b.dep_id));
          JoinMeetDump.map((item, idx) => {
            if (parseInt(item.salary) > 20000) {
              this.json_data.push({
                ...item,
                index: idx + 1,
                money_permiss: '15500'
              })
            } else {
              this.json_data.push({
                ...item,
                index: idx + 1,
                money_permiss: '11000'
              })
            }
          })
        } else {
          this.$swal.fire({
            icon: 'error',
            title: 'ไม่สามารถ Export ได้เนื่องจากโครงการที่เลือกไม่พบรายชื่อผู้ลงทะเบียนเข้าร่วมประชุม'
          })
        }
      }
      setTimeout(() => {
        item.IsExport = false
      }, 1000)
    },
    ExportPdfData(meetObj, cordi, type) {
      if (cordi) {
        this.dialogLoading = true
        this.html_data = ''
        var html_content = ''
        var html_content2 = ''
        var count = 1
        // var opts = {
        //   errorCorrectionLevel: 'H',
        //   type: 'image/jpeg',
        //   quality: 1,
        //   margin: 1,
        //   scale: 20
        // }
        // var qr = ''
        // this.url = ''
        if (this.JoinMeet.length == 0) {
          this.$swal.fire({
            icon: 'error',
            title: 'ไม่สามารถดาวน์โหลดรายชื่อได้ เนื่องจากไม่พบข้อมูลรายชื่อผู้เข้าร่วม !!'
          })
        } else {
          var JoinMeetFilter = (type ? this.JoinMeet.filter(itemJ => itemJ.status_reg == '1') : this.JoinMeet)
          if (JoinMeetFilter.length > 0) {
            if (type) {
              count = 1
              JoinMeetFilter.map((item) => {
                if (item.status_reg == '1') {
                  html_content += '' +
                    '<tbody>' +
                    '<tr>' +
                    '<td style="border:1px solid black;border-collapse: collapse;font-weight: bold">' + (count++) + '</td>' +
                    '<td style="border:1px solid black;border-collapse: collapse;font-weight: bold">' + ((item.uid != '' && item.uid != null) ? item.uid : '') + '</td>' +
                    '<td style="border:1px solid black;border-collapse: collapse;font-weight: bold">' + ((item.name != '' && item.name != null) ? item.name + ' ' + item.sname : '') + '</td>' +
                    '<td style="border:1px solid black;border-collapse: collapse;font-weight: bold">' + ((item.position != '' && item.position != null) ? item.position : '') + '</td>' +
                    '<td style="border:1px solid black;border-collapse: collapse;font-weight: bold">' + ((item.affiliation != '' && item.affiliation != null) ? item.affiliation : '') + '</td>' +
                    '<td style="border:1px solid black;border-collapse: collapse;font-weight: bold">' + ((item.type_details != '' && item.type_details != null) ? item.type_details : '') + '</td>' +
                    '</tr>' +
                    '</tbody>'
                }
              })
            } else {
              count = 1
              JoinMeetFilter.map((item) => {
                if (item.status_reg == '1') {
                  html_content += '' +
                    '<tbody>' +
                    '<tr>' +
                    '<td style="border:1px solid black;border-collapse: collapse;font-weight: bold">' + (count++) + '</td>' +
                    '<td style="border:1px solid black;border-collapse: collapse;font-weight: bold">' + ((item.uid != '' && item.uid != null) ? item.uid : '') + '</td>' +
                    '<td style="border:1px solid black;border-collapse: collapse;font-weight: bold">' + ((item.name != '' && item.name != null) ? item.name + ' ' + item.sname : '') + '</td>' +
                    '<td style="border:1px solid black;border-collapse: collapse;font-weight: bold">' + ((item.position != '' && item.position != null) ? item.position : '') + '</td>' +
                    '<td style="border:1px solid black;border-collapse: collapse;font-weight: bold">' + ((item.affiliation != '' && item.affiliation != null) ? item.affiliation : '') + '</td>' +
                    '<td style="border:1px solid black;border-collapse: collapse;font-weight: bold">' + ((item.type_details != '' && item.type_details != null) ? item.type_details : '') + '</td>' +
                    '</tr>' +
                    '</tbody>'
                }
              })
              count = 1
              JoinMeetFilter.map((item) => {
                if (item.status_reg == '0') {
                  html_content2 += '' +
                    '<tbody>' +
                    '<tr>' +
                    '<td style="border:1px solid black;border-collapse: collapse;font-weight: bold">' + (count++) + '</td>' +
                    '<td style="border:1px solid black;border-collapse: collapse;font-weight: bold">' + ((item.uid != '' && item.uid != null) ? item.uid : '') + '</td>' +
                    '<td style="border:1px solid black;border-collapse: collapse;font-weight: bold">' + ((item.name != '' && item.name != null) ? item.name + ' ' + item.sname : '') + '</td>' +
                    '<td style="border:1px solid black;border-collapse: collapse;font-weight: bold">' + ((item.position != '' && item.position != null) ? item.position : '') + '</td>' +
                    '<td style="border:1px solid black;border-collapse: collapse;font-weight: bold">' + ((item.affiliation != '' && item.affiliation != null) ? item.affiliation : '') + '</td>' +
                    '<td style="border:1px solid black;border-collapse: collapse;font-weight: bold">' + ((item.type_details != '' && item.type_details != null) ? item.type_details : '') + '</td>' +
                    '</tr>' +
                    '</tbody>'
                }
              })
            }
            this.html_data = (type ? '' +
              '<div>' +
              '<table style="border-collapse: collapse;width: 100%">' +
              '<thead>' +
              '<tr>' +
              '<th border="0" cellpadding="0" cellspacing="0" colspan="6"><h2 style="text-align: center;font-weight: bold;">' + meetObj.Topic + '</h2></th>' +
              '</tr>' +
              '<tr>' +
              '<th border="0" cellpadding="0" cellspacing="0" colspan="6"><p style="text-align: center;font-weight: bold;font-size: 16px">วันที่จัด ' + (meetObj.Date_start == meetObj.Date_end ? ('วันที่ ' + Vue.filter('DateToThai')(meetObj.Date_start) + ' เวลา ' + meetObj.Time_start + ' น. - ' + meetObj.Time_end + ' น.') : ('วันที่ ' + Vue.filter('DateToThai')(meetObj.Date_start) + ' ถึง ' + Vue.filter('DateToThai')(meetObj.Date_end) + ' เวลา ' + meetObj.Time_start + ' น. - ' + meetObj.Time_end + ' น.')) + '</p></th>' +
              '</tr>' +
              '<tr style="margin-bottom: 20px">' +
              '<th border="0" cellpadding="0" cellspacing="0" colspan="6"><p style="text-align: center;font-weight: bold;font-size: 16px">สถานที่จัด ' + meetObj.Place + '</p></th>' +
              '</tr>' +
              '<tr>' +
              '<br>' +
              '<th style="border:1px solid black;border-collapse: collapse;">ลำดับ</th>' +
              '<th style="border:1px solid black;border-collapse: collapse;">รหัสอ้างอิง</th>' +
              '<th style="border:1px solid black;border-collapse: collapse;">ชื่อ - สกุล</th>' +
              '<th style="border:1px solid black;border-collapse: collapse;">ตำแหน่ง</th>' +
              '<th style="border:1px solid black;border-collapse: collapse;">สังกัด</th>' +
              '<th style="border:1px solid black;border-collapse: collapse;">ประเภท</th>' +
              '</tr>' +
              '</thead>' +
              html_content +
              '</table>' +
              '<br>' +
              '<p style="text-align: center;font-weight: bold">' + ('ขอรับรองว่าได้เตรียมอาหาร ให้แก่ผู้เข้าร่วมอบรมจริง จำนวน ' + this.JoinMeet.filter(itemJ => itemJ.status_reg == '1').length + ' คน โดยผ่านระบบอิเลคทรอนิกส์ ไม่ได้ลงลายมือชื่อ') + '</p>' +
              '<br>' +
              '<br>' +
              '<br>' +
              '<p style="text-align: right;font-weight: bold">(.................................................................)</p>' +
              '<p style="text-align: right;font-weight: bold">(.................................................................)</p>' +
              '<p style="text-align: right;font-weight: bold;padding-right: 86px">ผู้รับรอง&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>' +
              '</div>' : '' +
              '<div>' +
              '<table style="border-collapse: collapse;width: 100%">' +
              '<thead>' +
              '<tr>' +
              '<th border="0" cellpadding="0" cellspacing="0" colspan="6"><h2 style="text-align: center;font-weight: bold;">' + meetObj.Topic + '</h2></th>' +
              '</tr>' +
              '<tr>' +
              '<th border="0" cellpadding="0" cellspacing="0" colspan="6"><p style="text-align: center;font-weight: bold;font-size: 16px">วันที่จัด ' + (meetObj.Date_start == meetObj.Date_end ? ('วันที่ ' + Vue.filter('DateToThai')(meetObj.Date_start) + ' เวลา ' + meetObj.Time_start + ' น. - ' + meetObj.Time_end + ' น.') : ('วันที่ ' + Vue.filter('DateToThai')(meetObj.Date_start) + ' ถึง ' + Vue.filter('DateToThai')(meetObj.Date_end) + ' เวลา ' + meetObj.Time_start + ' น. - ' + meetObj.Time_end + ' น.')) + '</p></th>' +
              '</tr>' +
              '<tr style="margin-bottom: 20px">' +
              '<th border="0" cellpadding="0" cellspacing="0" colspan="6"><p style="text-align: center;font-weight: bold;font-size: 16px">สถานที่จัด ' + meetObj.Place + '</p></th>' +
              '</tr>' +
              '<tr>' +
              '<br>' +
              '<th border="0" cellpadding="0" cellspacing="0" colspan="6"><p style="text-align: center;font-weight: bold;font-size: 16px">รายชื่อผู้ลงทะเบียนเข้าร่วม</p></th>' +
              '</tr>' +
              '<tr>' +
              '<br>' +
              '<th style="border:1px solid black;border-collapse: collapse;">ลำดับ</th>' +
              '<th style="border:1px solid black;border-collapse: collapse;">รหัสอ้างอิง</th>' +
              '<th style="border:1px solid black;border-collapse: collapse;">ชื่อ - สกุล</th>' +
              '<th style="border:1px solid black;border-collapse: collapse;">ตำแหน่ง</th>' +
              '<th style="border:1px solid black;border-collapse: collapse;">สังกัด</th>' +
              '<th style="border:1px solid black;border-collapse: collapse;">ประเภท</th>' +
              '</tr>' +
              '</thead>' +
              html_content +
              '</table>' +
              '<br>' +
              '<br>' +
              '<hr>' +
              '<br>' +
              '<br>' +
              '<table style="border-collapse: collapse;width: 100%">' +
              '<thead>' +
              '<tr>' +
              '<th border="0" cellpadding="0" cellspacing="0" colspan="6"><h2 style="text-align: center;font-weight: bold;">' + meetObj.Topic + '</h2></th>' +
              '</tr>' +
              '<tr>' +
              '<th border="0" cellpadding="0" cellspacing="0" colspan="6"><p style="text-align: center;font-weight: bold;font-size: 16px">วันที่จัด ' + (meetObj.Date_start == meetObj.Date_end ? ('วันที่ ' + Vue.filter('DateToThai')(meetObj.Date_start) + ' เวลา ' + meetObj.Time_start + ' น. - ' + meetObj.Time_end + ' น.') : ('วันที่ ' + Vue.filter('DateToThai')(meetObj.Date_start) + ' ถึง ' + Vue.filter('DateToThai')(meetObj.Date_end) + ' เวลา ' + meetObj.Time_start + ' น. - ' + meetObj.Time_end + ' น.')) + '</p></th>' +
              '</tr>' +
              '<tr style="margin-bottom: 20px">' +
              '<th border="0" cellpadding="0" cellspacing="0" colspan="6"><p style="text-align: center;font-weight: bold;font-size: 16px">สถานที่จัด ' + meetObj.Place + '</p></th>' +
              '</tr>' +
              '<tr>' +
              '<br>' +
              '<th border="0" cellpadding="0" cellspacing="0" colspan="6"><p style="text-align: center;font-weight: bold;font-size: 16px">รายชื่อผู้ไม่ได้ลงทะเบียนเข้าร่วม</p></th>' +
              '</tr>' +
              '<tr>' +
              '<br>' +
              '<th style="border:1px solid black;border-collapse: collapse;">ลำดับ</th>' +
              '<th style="border:1px solid black;border-collapse: collapse;">รหัสอ้างอิง</th>' +
              '<th style="border:1px solid black;border-collapse: collapse;">ชื่อ - สกุล</th>' +
              '<th style="border:1px solid black;border-collapse: collapse;">ตำแหน่ง</th>' +
              '<th style="border:1px solid black;border-collapse: collapse;">สังกัด</th>' +
              '<th style="border:1px solid black;border-collapse: collapse;">ประเภท</th>' +
              '</tr>' +
              '</thead>' +
              html_content2 +
              '</table>' +
              '<br>' +
              '<p style="text-align: center;font-weight: bold">' + ('ขอรับรองว่าได้เตรียมอาหาร ให้แก่ผู้เข้าร่วมอบรมจริง จำนวน ' + this.JoinMeet.length + ' คน โดยผ่านระบบอิเลคทรอนิกส์ ไม่ได้ลงลายมือชื่อ') + '</p>' +
              '<br>' +
              '<br>' +
              '<br>' +
              '<p style="text-align: right;font-weight: bold">(.................................................................)</p>' +
              '<p style="text-align: right;font-weight: bold">(.................................................................)</p>' +
              '<p style="text-align: right;font-weight: bold;padding-right: 86px">ผู้รับรอง&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>' +
            '</div>'
            )
            this.dialogLoading = false
            axios.post(ConstData.ConnectionHost + '/HrTrain2/Export2_QR_meeting.php', {
              Project_code: 'meeting_' + meetObj.id,
              title: meetObj.Topic,
              subject: meetObj.Topic,
              author: "",
              type: "0",
              id_Ref: meetObj.id,
              round_Ref: null,
              perid: this.MeData[0].perid,
              html_data: this.html_data,
            }, {
              headers: {
                'Content-Type': 'application/json',
              }
            }).then(res => {
              if (res.data.status) {
                this.dialogLoading = false
                window.open(ConstData.ConnectionHost + '/HrTrain2/GetFileReport.php?file_name=' + res.data.path, '_blank');
              } else {
                this.dialogLoading = false
                this.$swal.fire({
                  icon: 'error',
                  title: 'ไม่สามารถดาวน์โหลดรายชื่อได้ โปรดลองอีกครั้ง หรือ ติดต่อผู้ดูแลระบบ'
                })
              }
            }).catch(res => {
              if (res) {
                this.dialogLoading = false
                this.$swal.fire({
                  icon: 'error',
                  title: 'ไม่สามารถดาวน์โหลดรายชื่อได้ โปรดลองอีกครั้ง หรือ ติดต่อผู้ดูแลระบบ'
                })
              }
            })
          } else {
            this.dialogLoading = false
            this.$swal.fire({
              icon: 'error',
              title: 'ไม่สามารถดาวน์โหลดรายชื่อได้ เนื่องจากไม่พบข้อมูลลงทะเบียนจากผู้เข้าร่วม !!'
            })
          }
        }
      } else {
        this.dialogLoading = true
        axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_report/id_Ref/' + meetObj.id + '/active/1/?sort=id_DESC&limit=1').then(res => {
          if (res.data) {
            this.dialogLoading = false
            window.open(ConstData.ConnectionHost + '/HrTrain2/GetFileReport.php?file_name=' + res.data.file_name, '_blank');
          } else {
            this.dialogLoading = false
            this.$swal.fire({
              icon: 'error',
              title: 'พบข้อผิดพลาด ไม่พบข้อมูลสำเนารายชื่อ!!'
            })
          }
        })
      }
      setTimeout(() => {
        meetObj.IsExport = false
      }, 1000)
    },
    DelPic(id, idx) {
      this.DelFileId.push(id)
      this.FileMeetingToDb.splice(idx, 1)
    },
    DelMeeting(item) {
      this.CheckPermission().then(res => {
        if (res) {
          this.$swal.fire({
            title: 'ยืนยันการทำรายการ',
            text: "คุณต้องการลบข้อมูลการประชุม " + item.Topic + ' ใช่หรือไม่ ??',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'ตกลง',
            cancelButtonText: 'ยกเลิก'
          }).then((result) => {
            if (result.value) {
              this.dialogLoading = true
              axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_meeting/id/' + item.id, {
                active: '0',
                update_by: this.MeData[0].perid,
              }, this.headerAxios).then(res => {
                if (res.data.status) {
                  this.$swal.fire({
                    icon: 'success',
                    title: 'ลบข้อมูลประชุม ' + item.Topic + ' สำเร็จ'
                  })
                  this.init()
                  this.dialogLoading = false
                }
              })
            }
          })
        } else {
          this.$swal.fire({
            icon: 'error',
            title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
          })
        }
      })
    },
    RegisterMeeting(item) {
      this.CheckPermission().then(res => {
        if (res) {
          this.DelFileId = []
          this.JoinDel = []
          this.JoinMeet = []
          this.MeetingObj = null
          this.MeetingObj = item
          this.dialogReg = true
          this.tab = 'DataMeeting'
          this.Topic = item.Topic
          this.Count = item.Count
          this.Date_start = item.Date_start
          this.Date_reg_start = item.Date_reg_start
          this.Date_end = item.Date_end
          this.Date_reg_end = item.Date_reg_end
          this.Time_start = item.Time_start
          this.Time_end = item.Time_end
          this.DepSelect = item.dep_id
          this.Place = item.Place
          this.LinkGen = item.uuid
          this.url = item.url
          this.Rm = item.Rm
          this.Ref_id = item.Ref_id
          this.Cordi_Count = item.Count_cordi
          // this.updateDBservice(item.uuid)
          this.initJoinMeetingData({
            uuid: item.uuid,
            permiss_check: this.MeData[0].perid
          }).then(res => {
            if (res) {
              this.JoinMeet = this.JoinMeetingData
              this.JoinMeet.map((item, idx) => {
                item.idx = idx + 1
                item.IsDb = true
                item.full_Name = item.name + ' ' + item.sname
                item.idCard = item.id_card
              })
            }
          })
          this.initFileData({
            Ref_id: item.Ref_id
          }).then(res => {
            if (res) {
              this.FileMeetingToDb = this.FilesData
            }
          }).catch(resErr => {
            if (resErr) {
              this.FileMeetingToDb = []
            }
          })
        } else {
          this.$swal.fire({
            icon: 'error',
            title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
          })
        }
      })
    },
    updateDBservice(uuid) {
      setInterval(() => {
        this.initJoinMeetingData({
          uuid: uuid,
          permiss_check: this.MeData[0].perid
        }).then(res => {
          if (res) {
            // if (this.JoinMeetingData.length > 0 && this.JoinMeet.length > 0) {
            //   this.JoinMeetingData.map(joinData => {
            //     this.JoinMeet.map((joinMeet, idx) => {
            //       if (joinData.perid == joinMeet.perid) {
            //         checkMatch = true
            //       }
            //     })
            //     if (!checkMatch) {
            //       this.JoinMeet.push(joinData)
            //     }
            //   })

            this.JoinMeet = this.JoinMeetingData
            this.JoinMeet.map((item, idx) => {
              item.idx = idx + 1
              item.IsDb = true
            })
            // }
          }
        }).catch(res => {
          if (res) {
            this.JoinMeet = this.JoinMeetingData
          }
        })
      }, 1000)
    },
    EditMeeting(item) {
      this.CheckPermission().then(res => {
        if (res) {
          this.DelFileId = []
          this.JoinDel = []
          this.JoinMeet = []
          this.MeetingObj = null
          this.MeetingObj = item
          this.dialogEdit = true
          this.tab = 'DataMeeting'
          this.Topic = item.Topic
          this.Count = item.Count
          this.Date_start = item.Date_start
          this.Date_reg_start = item.Date_reg_start
          this.Date_end = item.Date_end
          this.Date_reg_end = item.Date_reg_end
          this.Time_start = item.Time_start
          this.Time_end = item.Time_end
          this.DepSelect = item.dep_id
          this.Place = item.Place
          this.LinkGen = item.uuid
          this.url = item.url
          this.Rm = item.Rm
          this.Ref_id = item.Ref_id
          this.Cordi_Count = item.Count_cordi
          this.initJoinMeetingData({
            uuid: item.uuid,
            permiss_check: this.MeData[0].perid
          }).then(res => {
            if (res) {
              this.JoinMeet = this.JoinMeetingData
              this.JoinMeet.map((item, idx) => {
                item.idx = idx + 1
                item.IsDb = true
              })
            }
          })
          this.initFileData({
            Ref_id: item.Ref_id
          }).then(res => {
            if (res) {
              this.FileMeetingToDb = this.FilesData
            }
          }).catch(resErr => {
            if (resErr) {
              this.FileMeetingToDb = []
            }
          })
        } else {
          this.$swal.fire({
            icon: 'error',
            title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
          })
        }
      })
    },
    Copy() {
      this.$swal.fire({
        position: 'top-end',
        icon: 'success',
        title: 'คัดลอกลิงค์',
        showConfirmButton: false,
        timer: 700
      })
    },
    ShowData: function (dataUrl) {
      window.open(
        dataUrl,
        '_blank' // <- This is what makes it open in a new window.
      );

    },
    FileSelect: function () {
      // var count = 0
      this.txtAlert = []
      this.FileMeeting = []
      this.alert = false
      if (this.files.length > 0) {
        this.files.map((item) => {
          var Checkfile = false;
          switch (item.type) {
            case 'image/jpg':
            case 'image/jpeg':
            case 'image/gif':
            case 'image/bmp':
            case 'image/png':
              Checkfile = true;
              break
            case 'application/pdf':
              Checkfile = true;
              break
            default:
              Checkfile = false;
              break
          }

          if (Checkfile) {
            if (item.size > 2048 * 2048) {
              this.txtAlert.push({
                id: this.txtAlert.length + 1,
                Detail: 'ไฟล์ ' + item.name + ' ขนาดเกิน 4 mb*'
              })
            }
          } else {
            this.txtAlert.push({
              id: this.txtAlert.length + 1,
              Detail: 'ไม่สนับสนุนนามสกุลไฟล์ ' + item.type.split('/')[1] + ' ( ' + item.name + ' ) '
            })
          }
        })
      }

      if (this.txtAlert.length == 0) {
        this.files.map((item) => {
          const fd = new FormData()
          fd.append('file', item, item.name)
          const headerAxios = {
            headers: {
              'Content-Type': 'multipart/form-data',
              'WithCredentials': true,
              "Access-Control-Allow-Origin": "*"
              // "Accept": 'multipart/form-data'
            }
          }

          axios.post(ConstData.ConnectionHost + '/rest/v1/hrcardnew/uploadfile', fd, headerAxios).then(res => {
            if (res.data.status) {
              switch (item.type) {
                case 'image/jpg':
                case 'image/jpeg':
                case 'image/gif':
                case 'image/bmp':
                case 'image/png':
                  this.FileMeeting.push({
                    name: item.name,
                    src: URL.createObjectURL(item),
                    path: res.data.path,
                    type: 'image',
                    type_Img: item.type,
                  })
                  break
                case 'application/pdf':
                  this.FileMeeting.push({
                    name: item.name,
                    src: URL.createObjectURL(item),
                    path: res.data.path,
                    type: 'pdf',
                    type_Img: item.type,
                  })
                  break
                default:
                  break
              }

              // count++
              //
              // if (count === this.files.length) {
              //     this.FileMeetingPdf = []
              //     this.FileMeeting = []
              // }
            }
          })
        })

      } else {
        this.alert = true
      }

    },
    DelData(idx) {
      this.JoinMeet.map((item, idx2) => {
        if (item.idx == idx) {
          this.JoinDel.push(item.id)
          this.JoinMeet.splice(idx2, 1)
        }
      })
      this.staffSel = ''
    },
    insertDataPerson(type) {
      if (type == 'person') {
        if (this.NameP == '' || this.SurNameP == '') {
          this.$swal.fire({
            icon: 'error',
            title: 'พบข้อผิดพลาด กรุณรากรอกข้อมูลให้ครบถ้วน'
          })
        } else {
          this.RegisterOtherPerson({
            D_meeting_uuid: this.MeetingObj.uuid,
            uid: 'P_' + this.JoinMeet.length,
            full_Name: this.NameP + ' ' + this.SurNameP,
            name: this.NameP,
            sname: this.SurNameP,
            idCard: this.idCard,
            affiliation: this.affiliation,
            position: this.position,
            phone: this.phoneOther,
            registerType_id: 4,
            status_reg: '1',
            files: [],
            type_details: 'บุคคลภายนอก'
          }).then(res => {
            if (res) {
              this.fetchJoinMeetData2()
              this.NameP = ''
              this.SurNameP = ''
              this.idCard = ''
              this.affiliation = ''
              this.position = ''
              this.phoneOther = ''
            } else {
              this.NameP = ''
              this.SurNameP = ''
              this.idCard = ''
              this.affiliation = ''
              this.position = ''
              this.phoneOther = ''
              this.$swal.fire({
                icon: 'error',
                title: 'พบข้อผิดพลาด ไม่สามารถเพิ่มข้อมูลได้ โปรดลองอีกครั้ง !!'
              })
            }
          })
        }
      } else {
        if (this.NameStd == '' || this.SurNameStd == '') {
          this.$swal.fire({
            icon: 'error',
            title: 'พบข้อผิดพลาด กรุณรากรอกข้อมูลให้ครบถ้วน'
          })
        } else {
          this.RegisterOtherPerson({
            D_meeting_uuid: this.MeetingObj.uuid,
            uid: 'S_' + this.JoinMeet.length,
            full_Name: this.NameStd + ' ' + this.SurNameStd,
            name: this.NameStd,
            sname: this.SurNameStd,
            idCard: this.idCardStd,
            affiliation: this.affiliationStd,
            position: '',
            phone: this.phoneOther,
            registerType_id: 5,
            status_reg: '1',
            files: [],
            type_details: 'นักศึกษาภายนอก'
          }).then(res => {
            if (res) {
              this.fetchJoinMeetData2()
              this.NameStd = ''
              this.SurNameStd = ''
              this.idCardStd = ''
              this.affiliationStd = ''
              this.phoneOther = ''
            } else {
              this.NameStd = ''
              this.SurNameStd = ''
              this.idCardStd = ''
              this.affiliationStd = ''
              this.phoneOther = ''
              this.$swal.fire({
                icon: 'error',
                title: 'พบข้อผิดพลาด ไม่สามารถเพิ่มข้อมูลได้ โปรดลองอีกครั้ง !!'
              })
            }
          })
        }
      }
    },
    insertPersonUni() {
      this.personalMedData.map(value => {
        if (this.IdPersonal == value.STAFF_ID) {
          this.RegisterOtherPerson({
            ...value,
            D_meeting_uuid: this.MeetingObj.uuid,
            uid: value.STAFF_ID,
            full_Name: value.STAFF_NAME_THAI + ' ' + value.STAFF_SNAME_THAI,
            name: value.STAFF_NAME_THAI,
            sname: value.STAFF_SNAME_THAI,
            idCard: value.STAFF_PERS_ID,
            affiliation: value.FAC_NAME_THAI,
            position: '',
            phone: '',
            registerType_id: 2,
            status_reg: '1',
            files: [],
            type_details: 'บุคลากรคณะอื่น'
          }).then(res => {
            if (res) {
              this.fetchJoinMeetData2()
              this.IdPersonal = ''
            } else {
              this.IdPersonal = ''
              this.$swal.fire({
                icon: 'error',
                title: 'พบข้อผิดพลาด ไม่สามารถเพิ่มข้อมูลได้ โปรดลองอีกครั้ง !!'
              })
            }
          })
        }
      })
    },
    insertStd(msg) {
      return new Promise(resolve => {
        var CheckDupe = false
        this.dialogLoading = true
        if (msg == 'med') {
          if (this.Idstudent != null) {
            if (this.Idstudent && typeof this.Idstudent === 'string') {
              // ตรวจสอบว่ามีตัวเลขหรือไม่
              const hasNumber = /\d/.test(this.Idstudent);
              // ตรวจสอบว่ามีอักขระและตัวเลขรวมกันหรือไม่
              const hasLetter = /[a-zA-Zก-๙]/.test(this.Idstudent);
              if (!hasNumber || (hasNumber && hasLetter)) {
                this.Idstudent = null
                this.dialogLoading = false;
                this.$swal.fire({
                  icon: 'error',
                  title: 'กรุณาเปลี่ยนภาษาบนคีย์บอร์ดเป็นภาษาอังกฤษก่อนสแกนหรือกรอกหมายเลข และห้ามมีอักขระกับตัวเลขรวมกัน',
                  showConfirmButton: false,
                  timer: 1500
                });
                setTimeout(() => {
                  if(this.joinTab == 0 && this.TypeRegStd == '0') {
                    if (this.$refs.staffSel && this.$refs.staffSel.$refs.input) {
                      this.$refs.staffSel.$refs.input.focus();
                    }
                  } else if(this.joinTab == 1 && this.TypeRegStd == '1') {
                    if (this.$refs.Idstudent && this.$refs.Idstudent.$refs.input) {
                      this.$refs.Idstudent.$refs.input.focus();
                    }
                  }
                }, 1000);
                return;
              }
            }
            if (this.Idstudent && typeof this.Idstudent === 'string') {
              // แปลงอักษรภาษาอังกฤษและไทยที่อยู่บนแป้นพิมพ์ตัวเลขกลับเป็นตัวเลข
              const keyMap = {
                'q': '1', 'Q': '1', 'ๅ': '1',
                'w': '2', 'W': '2', '/': '2',
                'e': '3', 'E': '3', 'ภ': '3',
                'r': '4', 'R': '4', 'ถ': '4',
                't': '5', 'T': '5', 'ุ': '5',
                'y': '6', 'Y': '6', 'ึ': '6',
                'u': '7', 'U': '7', 'ค': '7',
                'i': '8', 'I': '8', 'ต': '8',
                'o': '9', 'O': '9', 'จ': '9',
                'p': '0', 'P': '0', 'ข': '0'
              };
              let converted = '';
              for (let ch of this.Idstudent) {
                if (keyMap[ch]) {
                  converted += keyMap[ch];
                } else if (/\d/.test(ch)) {
                  converted += ch;
                }
                // ถ้าเป็นอักขระอื่นๆ ให้ข้าม
              }
              this.Idstudent = converted;
            }
            if (this.studentData.filter(stdI => stdI.STUDENT_ID == this.Idstudent).length > 0) {
              this.studentData.map(value => {
                if (this.Idstudent == value.STUDENT_ID) {
                  if (this.JoinMeet.filter(item => item.uid == value.STUDENT_ID).length > 0) {
                    CheckDupe = true
                  }
                  if (!CheckDupe) {
                    this.studentData.map(value => {
                      if (this.Idstudent == value.STUDENT_ID) {
                        this.RegisterOtherPerson({
                          ...value,
                          D_meeting_uuid: this.MeetingObj.uuid,
                          uid: value.STUDENT_ID,
                          full_Name: value.STUD_NAME_THAI + ' ' + value.STUD_SNAME_THAI,
                          name: value.STUD_NAME_THAI,
                          sname: value.STUD_SNAME_THAI,
                          idCard: value.CITIZEN_ID,
                          affiliation: 'คณะแพทยศาสตร์',
                          position: '',
                          phone: '',
                          registerType_id: 1,
                          status_reg: '1',
                          files: [],
                          type_details: 'นักศึกษาคณะแพทย์'
                        }).then(res => {
                          if (res) {
                            this.fetchJoinMeetData2()
                            this.Idstudent = null
                            this.dialogLoading = false
                            this.dialogStdReg = false
                          } else {
                            this.dialogLoading = false
                            this.Idstudent = null
                            this.dialogStdReg = false
                            this.$swal.fire({
                              icon: 'error',
                              title: 'พบข้อผิดพลาด ไม่สามารถเพิ่มข้อมูลได้ โปรดลองอีกครั้ง !!',
                              showConfirmButton: false,
                              timer: 700
                            })
                            setTimeout(() => {
                              if (this.$refs.Idstudent && this.$refs.Idstudent.$refs.input) {
                                this.$refs.Idstudent.$refs.input.focus();
                              }
                            }, 1000)
                            // this.alertBarColor = 'error'
                            // this.alertBarText = 'พบข้อผิดพลาด ไม่สามารถเพิ่มข้อมูลได้ โปรดลองอีกครั้ง !!'
                            // this.alertBar = true
                          }
                          resolve(true)
                        })
                      }
                    })
                  } else {
                    this.dialogLoading = false
                    this.$swal.fire({
                      icon: 'error',
                      title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว',
                      showConfirmButton: false,
                      timer: 700
                    })
                    setTimeout(() => {
                      if (this.$refs.Idstudent && this.$refs.Idstudent.$refs.input) {
                        this.$refs.Idstudent.$refs.input.focus();
                      }
                    }, 1000)
                  }
                }
              })
            } else {
              this.$swal.fire({
                icon: 'error',
                title: 'ไม่พบข้อมูล นักศึกษาโปรดตรวจสอบบัตรและข้อมูลนักศึกษาอีกครั้ง!',
                showConfirmButton: false,
                timer: 700
              })

              setTimeout(() => {
                if (this.$refs.Idstudent && this.$refs.Idstudent.$refs.input) {
                  this.$refs.Idstudent.$refs.input.focus();
                }
              }, 1000)
              // this.alertBarColor = 'error'
              // this.alertBarText = 'ไม่พบข้อมูล นักศึกษาโปรดตรวจสอบบัตรและข้อมูลนักศึกษาอีกครั้ง!'
              // this.alertBar = true
              this.dialogLoading = false
            }
          } else {
            this.$swal.fire({
              icon: 'error',
              title: 'โปรดระบุนักศึกษาก่อนทำรายการ!',
              showConfirmButton: false,
              timer: 700
            })
            setTimeout(() => {
              if (this.$refs.Idstudent && this.$refs.Idstudent.$refs.input) {
                this.$refs.Idstudent.$refs.input.focus();
              }
            }, 1000)
            // this.alertBarColor = 'error'
            // this.alertBarText = 'โปรดระบุนักศึกษาก่อนทำรายการ!'
            // this.alertBar = true
            this.dialogLoading = false
          }
        } else {
          this.studentUniData.map(value => {
            if (this.IdstudentUni == value.STUDENT_ID) {
              this.RegisterOtherPerson({
                ...value,
                D_meeting_uuid: this.MeetingObj.uuid,
                uid: value.STUDENT_ID,
                full_Name: value.STUD_NAME_THAI + ' ' + value.STUD_SNAME_THAI,
                name: value.STUD_NAME_THAI,
                sname: value.STUD_SNAME_THAI,
                idCard: value.CITIZEN_ID,
                affiliation: value.FAC_NAME_THAI,
                position: '',
                phone: '',
                registerType_id: 3,
                status_reg: '1',
                files: [],
                type_details: 'นักศึกษาคณะอื่น'
              }, '0').then(res => {
                if (res) {
                  this.fetchJoinMeetData2()
                  this.IdstudentUni = ''
                  this.dialogLoading = false
                } else {
                  this.dialogLoading = false
                  this.IdstudentUni = ''
                  this.$swal.fire({
                    icon: 'error',
                    title: 'พบข้อผิดพลาด ไม่สามารถเพิ่มข้อมูลได้ โปรดลองอีกครั้ง !!',
                    showConfirmButton: false,
                    timer: 700
                  })
                  setTimeout(() => {
                    if (this.$refs.IdstudentUni && this.$refs.IdstudentUni.$refs.input) {
                      this.$refs.IdstudentUni.$refs.input.focus();
                    }
                  }, 1000)
                  // this.alertBarColor = 'error'
                  // this.alertBarText = 'พบข้อผิดพลาด ไม่สามารถเพิ่มข้อมูลได้ โปรดลองอีกครั้ง !!'
                  // this.alertBar = true
                }
                resolve(true)
              })
            }
          })
        }
      })
    },
    InsertJoinMeet() {
      if (this.JoinMeet.length > 0) {
        if (this.JoinMeet.filter(item => item.uid == this.staffSel).length > 0) {
          this.staffSel = ''
          this.$swal.fire({
            icon: 'error',
            title: 'พบข้อผิดพลาด บุคลากรที่เลือกมีข้อมูลอยู่แล้ว!!'
          })
        } else {
          var Staff = this.staffData.filter(item => item.perid == this.staffSel)
          if (Staff.length > 0) {
            this.JoinMeet.unshift({
              ...Staff[0],
              // idx: this.JoinMeet.length + 1,
              status_reg: '0',
              IsDb: false
            })
            this.JoinMeet.map((item, idx) => {
              item.idx = idx + 1
            })
          }
        }
      } else {
        Staff = this.staffData.filter(item => item.perid == this.staffSel)
        if (Staff.length > 0) {
          this.JoinMeet.unshift({
            ...Staff[0],
            // idx: this.JoinMeet.length + 1,
            status_reg: '0',
            IsDb: false
          })
          this.JoinMeet.map((item, idx) => {
            item.idx = idx + 1
          })
        }
      }
    },
    checkKeyEnterStd(event) {
      if (event.key == "Enter") {
        if (this.Idstudent != null) {
          this.insertStd('med')
        } else if(this.$refs.Idstudent && this.$refs.Idstudent.$refs.input) {
          this.Idstudent = this.$refs.Idstudent.$refs.input.value;
          this.insertStd('med')
        } else {
          this.$swal.fire({
            icon: 'error',
            title: 'โปรดระบุนักศึกษาก่อนทำรายการ!',
            showConfirmButton: false,
            timer: 700
          })
          setTimeout(() => {
            if (this.$refs.Idstudent && this.$refs.Idstudent.$refs.input) {
              this.$refs.Idstudent.$refs.input.focus();
            }
          }, 1000)
        }
      }
    },
    checkKeyEnterStd2(event) {
      if (event.key == "Enter") {
        if (this.staffSel && typeof this.staffSel === 'string') {
          // ตรวจสอบว่ามีตัวเลขหรือไม่
          const hasNumber = /\d/.test(this.staffSel);
          // ตรวจสอบว่ามีอักขระและตัวเลขรวมกันหรือไม่
          const hasLetter = /[a-zA-Zก-๙]/.test(this.staffSel);
          if (!hasNumber || (hasNumber && hasLetter)) {
            this.staffSel = '';
            this.dialogLoading = false;
            this.$swal.fire({
            icon: 'error',
            title: 'กรุณาเปลี่ยนภาษาบนคีย์บอร์ดเป็นภาษาอังกฤษก่อนสแกนหรือกรอกหมายเลข และห้ามมีอักขระกับตัวเลขรวมกัน',
            showConfirmButton: false,
            timer: 1500
            });
            setTimeout(() => {
              if(this.joinTab == 0 && this.TypeRegStd == '0') {
                if (this.$refs.staffSel && this.$refs.staffSel.$refs.input) {
                  this.$refs.staffSel.$refs.input.focus();
                }
              } else if(this.joinTab == 1 && this.TypeRegStd == '1') {
                if (this.$refs.Idstudent && this.$refs.Idstudent.$refs.input) {
                  this.$refs.Idstudent.$refs.input.focus();
                }
              }
            }, 1000);
            return;
          }
        }
        if (this.staffSel && typeof this.staffSel === 'string') {
          // แปลงอักษรภาษาอังกฤษและไทยที่อยู่บนแป้นพิมพ์ตัวเลขกลับเป็นตัวเลข
          const keyMap = {
          'q': '1', 'Q': '1', 'ๅ': '1',
          'w': '2', 'W': '2', '/': '2',
          'e': '3', 'E': '3', 'ภ': '3',
          'r': '4', 'R': '4', 'ถ': '4',
          't': '5', 'T': '5', 'ุ': '5',
          'y': '6', 'Y': '6', 'ึ': '6',
          'u': '7', 'U': '7', 'ค': '7',
          'i': '8', 'I': '8', 'ต': '8',
          'o': '9', 'O': '9', 'จ': '9',
          'p': '0', 'P': '0', 'ข': '0'
          };
          let converted = '';
          for (let ch of this.staffSel) {
          if (keyMap[ch]) {
            converted += keyMap[ch];
          } else if (/\d/.test(ch)) {
            converted += ch;
          }
          // ถ้าเป็นอักขระอื่นๆ ให้ข้าม
          }
          this.staffSel = converted;
        }
        this.card_no = this.staffSel
        this.getCardDataMedStudent({
          card_no: this.staffSel
        }).then(res => {
          if (res) {
            if (this.CardData2.length > 0) {
              this.Idstudent = this.CardData2[0].uid
              this.staffSel = ''
              this.insertStd('med')
            } else {
              this.dialogLoading = false
              this.CheckMeetigCordi = true
              this.staffSel = ''
              this.$swal.fire({
                icon: 'error',
                title: 'ไม่พบข้อมูลหมายเลข !!',
                showConfirmButton: false,
                timer: 700
              })
              this.Idstudent = null
              this.dialogStdReg = true
            }
          } else {
            this.dialogLoading = false
            this.CheckMeetigCordi = true
            this.staffSel = ''
            this.Idstudent = null
            this.$swal.fire({
              icon: 'error',
              title: 'ไม่พบข้อมูลหมายเลข !!',
              showConfirmButton: false,
              timer: 700
            })
            this.dialogStdReg = true
          }
        })
      }
    },
    checkKeyEnter(event) {
      if (event.key == "Enter") {
        if (this.JoinMeet.length > 0) {
          if (this.JoinMeet.filter(item => item.uid == this.staffSel).length > 0) {
            this.staffSel = ''
            this.$swal.fire({
              icon: 'error',
              title: 'พบข้อผิดพลาด บุคลากรที่เลือกมีข้อมูลอยู่แล้ว!!'
            })
          } else {
            var Staff = this.staffData.filter(item => item.perid == this.staffSel)
            if (Staff.length > 0) {
              this.JoinMeet.unshift({
                ...Staff[0],
                // idx: 0,
                status_reg: '0',
                IsDb: false
              })
              this.JoinMeet.map((item, idx) => {
                item.idx = idx + 1
              })
            }
          }
        } else {
          Staff = this.staffData.filter(item => item.perid == this.staffSel)
          if (Staff.length > 0) {
            this.JoinMeet.unshift({
              ...Staff[0],
              // idx: this.JoinMeet.length + 1
              status_reg: '0',
              idx: 0
            })
            this.JoinMeet.map((item, idx) => {
              item.idx = idx + 1
            })
          }
        }
        this.staffSel = ''
      }
    },
    GenerateUrl(item) {
      return new Promise(resolve => {
        TinyURL.shorten(ConstData.PreGenerateLink + item.uuid).then(function (res) {
          resolve(res)
        }, function (err) {
          console.log(err)
        })
      })
    },
    ChooseCordiCount() {
      if (this.Cordi_Count == '0') {
        this.Count = '0'
      }
    },
    getRandomFileName() {
      var timestamp = new Date().toISOString().replace(/[-:.]/g, "");
      var random = ("" + Math.random()).substring(2, 8);
      var random_number = timestamp + random;
      return random_number;
    },
    RegisterPersonUnlock() {
      this.CheckMeetigCordi = false
      this.dialogLoading = true
      if (this.staffSel == '') {
        this.dialogLoading = false
        this.$swal.fire({
          icon: 'error',
          title: 'โปรดสแกนบัตรบุคลากร หรือ กรอกข้อมูลรหัสบุคลากรก่อนทำการลงทะเบียน',
          showConfirmButton: false,
          timer: 700
        })
        setTimeout(() => {
          if (this.$refs.staffSel && this.$refs.staffSel.$refs.input) {
            this.$refs.staffSel.$refs.input.focus();
          }
        }, 1000)
      } else {
        if (this.MeetingCordiData.length > 0) {
          if (this.MeetingCordiData.filter(item => item.D_meeting_id == this.MeetingObj.id).length > 0) {
            if (this.staffSel && typeof this.staffSel === 'string') {
              // ตรวจสอบว่ามีตัวเลขหรือไม่
              const hasNumber = /\d/.test(this.staffSel);
              // ตรวจสอบว่ามีอักขระและตัวเลขรวมกันหรือไม่
              const hasLetter = /[a-zA-Zก-๙]/.test(this.staffSel);
              if (!hasNumber || (hasNumber && hasLetter)) {
                this.staffSel = '';
                this.dialogLoading = false;
                this.$swal.fire({
                  icon: 'error',
                  title: 'กรุณาเปลี่ยนภาษาบนคีย์บอร์ดเป็นภาษาอังกฤษก่อนสแกนหรือกรอกหมายเลข และห้ามมีอักขระกับตัวเลขรวมกัน',
                  showConfirmButton: false,
                  timer: 1500
                });
                setTimeout(() => {
                  if(this.joinTab == 0 && this.TypeRegStd == '0') {
                    if (this.$refs.staffSel && this.$refs.staffSel.$refs.input) {
                      this.$refs.staffSel.$refs.input.focus();
                    }
                  } else if(this.joinTab == 1 && this.TypeRegStd == '1') {
                    if (this.$refs.Idstudent && this.$refs.Idstudent.$refs.input) {
                      this.$refs.Idstudent.$refs.input.focus();
                    }
                  }
                }, 1000);
                return;
              }
            }
            if (this.staffSel && typeof this.staffSel === 'string') {
              // แปลงอักษรภาษาอังกฤษและไทยที่อยู่บนแป้นพิมพ์ตัวเลขกลับเป็นตัวเลข
              const keyMap = {
                'q': '1', 'Q': '1', 'ๅ': '1',
                'w': '2', 'W': '2', '/': '2',
                'e': '3', 'E': '3', 'ภ': '3',
                'r': '4', 'R': '4', 'ถ': '4',
                't': '5', 'T': '5', 'ุ': '5',
                'y': '6', 'Y': '6', 'ึ': '6',
                'u': '7', 'U': '7', 'ค': '7',
                'i': '8', 'I': '8', 'ต': '8',
                'o': '9', 'O': '9', 'จ': '9',
                'p': '0', 'P': '0', 'ข': '0'
              };
              let converted = '';
              for (let ch of this.staffSel) {
                if (keyMap[ch]) {
                  converted += keyMap[ch];
                } else if (/\d/.test(ch)) {
                  converted += ch;
                }
                // ถ้าเป็นอักขระอื่นๆ ให้ข้าม
              }
              this.staffSel = converted;
            }
            if (this.staffSel.length <= 5) {
              var DataEmp = this.staffData.filter(item => item.perid == this.staffSel)
              if (DataEmp.length > 0) {
                var DataJoinEmp = this.JoinMeet.filter(item => item.uid == this.staffSel)
                if (DataJoinEmp.length == 0) {
                  this.dialogLoading = false
                  this.CheckMeetigCordi = true
                  this.staffSel = ''
                  this.$swal.fire({
                    icon: 'error',
                    title: 'ไม่สามารถลงทะเบียนได้เนื่องจากไม่พบรายชื่อผู้เข้าร่วม',
                    showConfirmButton: false,
                    timer: 700
                  })
                  setTimeout(() => {
                    if (this.$refs.staffSel && this.$refs.staffSel.$refs.input) {
                      this.$refs.staffSel.$refs.input.focus();
                    }
                  }, 1000)
                }
              } else {
                this.dialogLoading = false
                this.CheckMeetigCordi = true
                this.staffSel = ''
                this.$swal.fire({
                  icon: 'error',
                  title: 'ไม่พบข้อมูลรหัสบุคลากร',
                  showConfirmButton: false,
                  timer: 700
                })
                setTimeout(() => {
                  if (this.$refs.staffSel && this.$refs.staffSel.$refs.input) {
                    this.$refs.staffSel.$refs.input.focus();
                  }
                }, 1000)
              }
            } else {
              var CardEmp = this.CardData.filter(item => item.CARD_NO == ('' + parseInt(this.staffSel)))
              if (CardEmp.length > 0) {
                CardEmp = this.UniqueArraybyId(CardEmp, 'PERID')
                if (CardEmp.length == 1) {
                  DataEmp = this.staffData.filter(item => item.perid == CardEmp[0].PERID)
                  if (DataEmp.length > 0) {
                    DataJoinEmp = this.JoinMeet.filter(item => item.uid == CardEmp[0].PERID)
                    if (DataJoinEmp.length == 0) {
                      this.dialogLoading = false
                      this.CheckMeetigCordi = true
                      this.staffSel = ''
                      this.$swal.fire({
                        icon: 'error',
                        title: 'ไม่สามารถลงทะเบียนได้เนื่องจากไม่พบรายชื่อผู้เข้าร่วม',
                        showConfirmButton: false,
                        timer: 700
                      })
                      setTimeout(() => {
                        if (this.$refs.staffSel && this.$refs.staffSel.$refs.input) {
                          this.$refs.staffSel.$refs.input.focus();
                        }
                      }, 1000)
                    }
                  } else {
                    this.dialogLoading = false
                    this.CheckMeetigCordi = true
                    this.staffSel = ''
                    this.$swal.fire({
                      icon: 'error',
                      title: 'ไม่พบข้อมูลรหัสบุคลากร',
                      showConfirmButton: false,
                      timer: 700
                    })
                    setTimeout(() => {
                      if (this.$refs.staffSel && this.$refs.staffSel.$refs.input) {
                        this.$refs.staffSel.$refs.input.focus();
                      }
                    }, 1000)
                  }
                } else {
                  this.dialogLoading = false
                  this.CheckMeetigCordi = true
                  this.staffSel = ''
                  this.$swal.fire({
                    icon: 'error',
                    title: 'พบข้อมูลหมายเลขบัตรดังกล่าว ซํ้ากับผู้อื่น !!',
                    showConfirmButton: false,
                    timer: 700
                  })
                  setTimeout(() => {
                    if (this.$refs.staffSel && this.$refs.staffSel.$refs.input) {
                      this.$refs.staffSel.$refs.input.focus();
                    }
                  }, 1000)
                }
              } else {
                this.getCardDataMedStudent({
                  card_no: this.staffSel
                }).then(res => {
                  if (res) {
                    if (this.CardData2.length > 0) {
                      this.Idstudent = this.CardData2[0].uid
                      this.staffSel = ''
                      this.insertStd('med')
                    } else {
                      this.dialogLoading = false
                      this.CheckMeetigCordi = true
                      this.staffSel = ''
                      this.$swal.fire({
                        icon: 'error',
                        title: 'ไม่พบข้อมูลหมายเลข !!',
                        showConfirmButton: false,
                        timer: 700
                      })
                      setTimeout(() => {
                        if (this.$refs.staffSel && this.$refs.staffSel.$refs.input) {
                          this.$refs.staffSel.$refs.input.focus();
                        }
                      }, 1000)
                    }
                  } else {
                    this.dialogLoading = false
                    this.CheckMeetigCordi = true
                    this.staffSel = ''
                    this.$swal.fire({
                      icon: 'error',
                      title: 'ไม่พบข้อมูลหมายเลข !!',
                      showConfirmButton: false,
                      timer: 700
                    })
                    setTimeout(() => {
                      if (this.$refs.staffSel && this.$refs.staffSel.$refs.input) {
                        this.$refs.staffSel.$refs.input.focus();
                      }
                    }, 1000)
                  }
                })
              }
            }
          }
        }
        if (!this.CheckMeetigCordi) {
          if (this.staffSel && typeof this.staffSel === 'string') {
            // ตรวจสอบว่ามีตัวเลขหรือไม่
            const hasNumber = /\d/.test(this.staffSel);
            // ตรวจสอบว่ามีอักขระและตัวเลขรวมกันหรือไม่
            const hasLetter = /[a-zA-Zก-๙]/.test(this.staffSel);
            if (!hasNumber || (hasNumber && hasLetter)) {
              this.staffSel = '';
              this.dialogLoading = false;
              this.$swal.fire({
                icon: 'error',
                title: 'กรุณาเปลี่ยนภาษาบนคีย์บอร์ดเป็นภาษาอังกฤษก่อนสแกนหรือกรอกหมายเลข และห้ามมีอักขระกับตัวเลขรวมกัน',
                showConfirmButton: false,
                timer: 1500
              });
              setTimeout(() => {
                if(this.joinTab == 0 && this.TypeRegStd == '0') {
                  if (this.$refs.staffSel && this.$refs.staffSel.$refs.input) {
                    this.$refs.staffSel.$refs.input.focus();
                  }
                } else if(this.joinTab == 1 && this.TypeRegStd == '1') {
                  if (this.$refs.Idstudent && this.$refs.Idstudent.$refs.input) {
                    this.$refs.Idstudent.$refs.input.focus();
                  }
                }
              }, 1000);
              return;
            }
          }
          if (this.staffSel && typeof this.staffSel === 'string') {
            // แปลงอักษรภาษาอังกฤษและไทยที่อยู่บนแป้นพิมพ์ตัวเลขกลับเป็นตัวเลข
            const keyMap = {
              'q': '1', 'Q': '1', 'ๅ': '1',
              'w': '2', 'W': '2', '/': '2',
              'e': '3', 'E': '3', 'ภ': '3',
              'r': '4', 'R': '4', 'ถ': '4',
              't': '5', 'T': '5', 'ุ': '5',
              'y': '6', 'Y': '6', 'ึ': '6',
              'u': '7', 'U': '7', 'ค': '7',
              'i': '8', 'I': '8', 'ต': '8',
              'o': '9', 'O': '9', 'จ': '9',
              'p': '0', 'P': '0', 'ข': '0'
            };
            let converted = '';
            for (let ch of this.staffSel) {
              if (keyMap[ch]) {
                converted += keyMap[ch];
              } else if (/\d/.test(ch)) {
                converted += ch;
              }
              // ถ้าเป็นอักขระอื่นๆ ให้ข้าม
            }
            this.staffSel = converted;
          }
          if (this.staffSel.length <= 5) {
            DataEmp = this.staffData.filter(item => item.perid == this.staffSel)
            if (DataEmp.length > 0) {
              DataJoinEmp = this.JoinMeet.filter(item => item.uid == this.staffSel)
              if (DataJoinEmp.length > 0) {
                axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_meeting_join2/D_meeting_uuid/' + DataJoinEmp[0].D_meeting_uuid + '/uid/' + this.staffSel, {
                  // axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_meeting_join2/perid/' + this.staffSel, {
                  status_reg: '1',
                  update_by: this.MeData[0].perid,
                }, this.headerAxios).then(async res => {
                  if (res.data.status) {
                    await axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/History_Experts/perid/' + this.staffSel + '/D_meeting_id/' + this.MeetingObj.id + '/?limit=1').then(async resHis => {
                      if (resHis.data) {
                        if (resHis.data.active == '0') {
                          await axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/History_Experts/id/' + resHis.data.id, {
                            active: '1',
                            update_by: this.MeData[0].perid,
                          }, this.headerAxios).then(resUpdate => {
                            if (resUpdate.data.status) {
                              this.dialogLoading = false
                              this.staffSel = ''
                              this.fetchJoinMeetData2()
                              this.$swal.fire({
                                icon: 'success',
                                title: 'รหัสบุคลากร ' + DataEmp[0].perid + ' : ' + DataEmp[0].full_Name + ' ลงทะเบียนเข้าร่วมประชุมสำเร็จ !!',
                                showConfirmButton: false,
                                timer: 700
                              })
                              setTimeout(() => {
                                if (this.$refs.staffSel && this.$refs.staffSel.$refs.input) {
                                  this.$refs.staffSel.$refs.input.focus();
                                }
                              }, 1000)
                            }
                          })
                        } else {
                          this.dialogLoading = false
                          this.staffSel = ''
                          this.fetchJoinMeetData2()
                          this.$swal.fire({
                            icon: 'success',
                            title: 'รหัสบุคลากร ' + DataEmp[0].perid + ' : ' + DataEmp[0].full_Name + ' ลงทะเบียนเข้าร่วมประชุมสำเร็จ !!',
                            showConfirmButton: false,
                            timer: 700
                          })
                          setTimeout(() => {
                            if (this.$refs.staffSel && this.$refs.staffSel.$refs.input) {
                              this.$refs.staffSel.$refs.input.focus();
                            }
                          }, 1000)
                        }
                      } else {
                        await axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/History_Experts/', {
                          perid: this.staffSel,
                          Project_code: '',
                          Project_name: '',
                          date_travel_start: '0000-00-00',
                          date_travel_end: '0000-00-00',
                          time_start: this.MeetingObj.Time_start,
                          time_end: this.MeetingObj.Time_end,
                          subject: this.MeetingObj.Topic,
                          type: '15',
                          date_start: this.MeetingObj.Date_start,
                          date_end: this.MeetingObj.Date_end,
                          Rm: this.MeetingObj.Rm,
                          Ref_id: this.MeetingObj.Ref_id,
                          D_meeting_id: this.MeetingObj.id,
                          create_by: this.MeData[0].perid,
                          create_time: 'now()',
                        }, this.headerAxiosPUT).then(resPut => {
                          if (resPut.data.status) {
                            this.dialogLoading = false
                            this.staffSel = ''
                            this.fetchJoinMeetData2()
                            this.$swal.fire({
                              icon: 'success',
                              title: 'รหัสบุคลากร ' + DataEmp[0].perid + ' : ' + DataEmp[0].full_Name + ' ลงทะเบียนเข้าร่วมประชุมสำเร็จ !!',
                              showConfirmButton: false,
                              timer: 700
                            })
                            setTimeout(() => {
                              if (this.$refs.staffSel && this.$refs.staffSel.$refs.input) {
                                this.$refs.staffSel.$refs.input.focus();
                              }
                            }, 1000)
                          }
                        })
                      }
                    })
                  } else {
                    this.dialogLoading = false
                    this.staffSel = ''
                    this.$swal.fire({
                      icon: 'error',
                      title: 'พบข้อผิดพลาด ไม่สามารถบันทึกข้อมูลผู้เข้าร่วมประชุมได้ โปรดติดต่อ ฝ่าย IT',
                      showConfirmButton: false,
                      timer: 700
                    })
                    setTimeout(() => {
                      if (this.$refs.staffSel && this.$refs.staffSel.$refs.input) {
                        this.$refs.staffSel.$refs.input.focus();
                      }
                    }, 1000)
                  }
                })
              } else {
                /*axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_meeting_join2', {
                  perid: this.staffSel,
                  D_meeting_uuid: this.LinkGen,
                  status_reg: '1',
                  create_by: this.MeData[0].perid,
                  create_time: 'now()',
                }, this.headerAxiosPUT).then(resJoinMeet => {*/
                var Staff = this.staffData.filter(item => item.perid == this.staffSel)
                if (Staff.length > 0) {
                  axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_meeting_join2', {
                    status_reg: '1',
                    D_meeting_uuid: this.LinkGen,
                    uid: Staff[0].perid,
                    name: Staff[0].name,
                    sname: Staff[0].surname,
                    id_card: Staff[0].citizen_id,
                    affiliation: Staff[0].dep_name,
                    position: Staff[0].pos_name,
                    phone: '',
                    registerType_id: 0,
                    Create_By: this.MeData[0].perid,
                    Create_Time: 'now()',
                  }, this.headerAxiosPUT).then(resJoinMeet => {
                    if (resJoinMeet.status) {
                      axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/History_Experts/', {
                        perid: this.staffSel,
                        Project_code: '',
                        Project_name: '',
                        date_travel_start: '0000-00-00',
                        date_travel_end: '0000-00-00',
                        time_start: this.MeetingObj.Time_start,
                        time_end: this.MeetingObj.Time_end,
                        subject: this.MeetingObj.Topic,
                        type: '15',
                        date_start: this.MeetingObj.Date_start,
                        date_end: this.MeetingObj.Date_end,
                        Rm: this.MeetingObj.Rm,
                        Ref_id: this.MeetingObj.Ref_id,
                        D_meeting_id: this.MeetingObj.id,
                        create_by: this.MeData[0].perid,
                        create_time: 'now()',
                      }, this.headerAxiosPUT)
                      this.dialogLoading = false
                      this.staffSel = ''
                      this.fetchJoinMeetData2()
                      this.$swal.fire({
                        icon: 'success',
                        title: 'รหัสบุคลากร ' + DataEmp[0].perid + ' : ' + DataEmp[0].full_Name + ' ลงทะเบียนเข้าร่วมประชุมสำเร็จ !!',
                        showConfirmButton: false,
                        timer: 700
                      })
                      setTimeout(() => {
                        if (this.$refs.staffSel && this.$refs.staffSel.$refs.input) {
                          this.$refs.staffSel.$refs.input.focus();
                        }
                      }, 1000)
                    } else {
                      this.dialogLoading = false
                      this.staffSel = ''
                      this.$swal.fire({
                        icon: 'error',
                        title: 'พบข้อผิดพลาด ไม่สามารถบันทึกข้อมูลผู้เข้าร่วมประชุมได้ โปรดติดต่อ ฝ่าย IT',
                        showConfirmButton: false,
                        timer: 700
                      })
                      setTimeout(() => {
                        if (this.$refs.staffSel && this.$refs.staffSel.$refs.input) {
                          this.$refs.staffSel.$refs.input.focus();
                        }
                      }, 1000)
                    }
                  })
                } else {
                  this.dialogLoading = false
                  this.staffSel = ''
                  this.$swal.fire({
                    icon: 'error',
                    title: 'พบข้อผิดพลาด ไม่สามารถบันทึกข้อมูลผู้เข้าร่วมประชุมได้ โปรดติดต่อ ฝ่าย IT',
                    showConfirmButton: false,
                    timer: 700
                  })
                  setTimeout(() => {
                    if (this.$refs.staffSel && this.$refs.staffSel.$refs.input) {
                      this.$refs.staffSel.$refs.input.focus();
                    }
                  }, 1000)
                }
              }
            } else {
              this.dialogLoading = false
              this.staffSel = ''
              this.$swal.fire({
                icon: 'error',
                title: 'ไม่พบข้อมูลรหัสบุคลากร',
                showConfirmButton: false,
                timer: 700
              })
              setTimeout(() => {
                if (this.$refs.staffSel && this.$refs.staffSel.$refs.input) {
                  this.$refs.staffSel.$refs.input.focus();
                }
              }, 1000)
            }
          } else {
            CardEmp = this.CardData.filter(item => item.CARD_NO == ('' + parseInt(this.staffSel)))
            if (CardEmp.length > 1) {
              CardEmp = this.UniqueArraybyId(CardEmp, 'PERID')
              if (CardEmp.length == 1) {
                DataEmp = this.staffData.filter(item => item.perid == CardEmp[0].PERID)
                if (DataEmp.length > 0) {
                  DataJoinEmp = this.JoinMeet.filter(item => item.uid == CardEmp[0].PERID)
                  if (DataJoinEmp.length > 0) {
                    axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_meeting_join2/D_meeting_uuid/' + DataJoinEmp[0].D_meeting_uuid + '/uid/' + DataEmp[0].perid, {
                      // axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_meeting_join2/perid/' + DataEmp[0].perid, {
                      status_reg: '1',
                      update_by: this.MeData[0].perid,
                    }, this.headerAxios).then(async res => {
                      if (res.data.status) {
                        await axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/History_Experts/perid/' + DataEmp[0].perid + '/D_meeting_id/' + this.MeetingObj.id + '/?limit=1').then(async resHis => {
                          if (resHis.data) {
                            if (resHis.data.active == '0') {
                              await axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/History_Experts/id/' + resHis.data.id, {
                                active: '1',
                                update_by: this.MeData[0].perid,
                              }, this.headerAxios).then(resUpdate => {
                                if (resUpdate.data.status) {
                                  this.dialogLoading = false
                                  this.staffSel = ''
                                  this.fetchJoinMeetData2()
                                  this.$swal.fire({
                                    icon: 'success',
                                    title: 'รหัสบุคลากร ' + DataEmp[0].perid + ' : ' + DataEmp[0].full_Name + ' ลงทะเบียนเข้าร่วมประชุมสำเร็จ !!',
                                    showConfirmButton: false,
                                    timer: 700
                                  })
                                  setTimeout(() => {
                                    if (this.$refs.staffSel && this.$refs.staffSel.$refs.input) {
                                      this.$refs.staffSel.$refs.input.focus();
                                    }
                                  }, 1000)
                                }
                              })
                            } else {
                              this.dialogLoading = false
                              this.staffSel = ''
                              this.fetchJoinMeetData2()
                              this.$swal.fire({
                                icon: 'success',
                                title: 'รหัสบุคลากร ' + DataEmp[0].perid + ' : ' + DataEmp[0].full_Name + ' ลงทะเบียนเข้าร่วมประชุมสำเร็จ !!',
                                showConfirmButton: false,
                                timer: 700
                              })
                              setTimeout(() => {
                                if (this.$refs.staffSel && this.$refs.staffSel.$refs.input) {
                                  this.$refs.staffSel.$refs.input.focus();
                                }
                              }, 1000)
                            }
                          } else {
                            await axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/History_Experts/', {
                              perid: DataEmp[0].perid,
                              Project_code: '',
                              Project_name: '',
                              date_travel_start: '0000-00-00',
                              date_travel_end: '0000-00-00',
                              time_start: this.MeetingObj.Time_start,
                              time_end: this.MeetingObj.Time_end,
                              subject: this.MeetingObj.Topic,
                              type: '15',
                              date_start: this.MeetingObj.Date_start,
                              date_end: this.MeetingObj.Date_end,
                              Rm: this.MeetingObj.Rm,
                              Ref_id: this.MeetingObj.Ref_id,
                              D_meeting_id: this.MeetingObj.id,
                              create_by: this.MeData[0].perid,
                              create_time: 'now()',
                            }, this.headerAxiosPUT).then(resPut => {
                              if (resPut.data.status) {
                                this.dialogLoading = false
                                this.staffSel = ''
                                this.fetchJoinMeetData2()
                                this.$swal.fire({
                                  icon: 'success',
                                  title: 'รหัสบุคลากร ' + DataEmp[0].perid + ' : ' + DataEmp[0].full_Name + ' ลงทะเบียนเข้าร่วมประชุมสำเร็จ !!',
                                  showConfirmButton: false,
                                  timer: 700
                                })
                                setTimeout(() => {
                                  if (this.$refs.staffSel && this.$refs.staffSel.$refs.input) {
                                    this.$refs.staffSel.$refs.input.focus();
                                  }
                                }, 1000)
                              }
                            })
                          }
                        })
                      } else {
                        this.dialogLoading = false
                        this.staffSel = ''
                        this.$swal.fire({
                          icon: 'error',
                          title: 'ไม่พบข้อมูลรายชื่อผู้เข้าร่วมการประชุม',
                          showConfirmButton: false,
                          timer: 700
                        })
                        setTimeout(() => {
                          if (this.$refs.staffSel && this.$refs.staffSel.$refs.input) {
                            this.$refs.staffSel.$refs.input.focus();
                          }
                        }, 1000)
                      }
                    })
                  } else {
                    /*axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_meeting_join2', {
                      perid: DataEmp[0].perid,
                      D_meeting_uuid: this.LinkGen,
                      status_reg: '1',
                      create_by: this.MeData[0].perid,
                      create_time: 'now()',
                    }, this.headerAxiosPUT).then(resJoinMeet => {*/
                    Staff = this.staffData.filter(item => item.perid == DataEmp[0].perid)
                    if (Staff.length > 0) {
                      axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_meeting_join2', {
                        status_reg: '1',
                        D_meeting_uuid: this.LinkGen,
                        uid: Staff[0].perid,
                        name: Staff[0].name,
                        sname: Staff[0].surname,
                        id_card: Staff[0].citizen_id,
                        affiliation: Staff[0].dep_name,
                        position: Staff[0].pos_name,
                        phone: '',
                        registerType_id: 0,
                        Create_By: this.MeData[0].perid,
                        Create_Time: 'now()',
                      }, this.headerAxiosPUT).then(resJoinMeet => {
                        if (resJoinMeet.status) {
                          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/History_Experts/', {
                            perid: DataEmp[0].perid,
                            Project_code: '',
                            Project_name: '',
                            date_travel_start: '0000-00-00',
                            date_travel_end: '0000-00-00',
                            time_start: this.MeetingObj.Time_start,
                            time_end: this.MeetingObj.Time_end,
                            subject: this.MeetingObj.Topic,
                            type: '15',
                            date_start: this.MeetingObj.Date_start,
                            date_end: this.MeetingObj.Date_end,
                            Rm: this.MeetingObj.Rm,
                            Ref_id: this.MeetingObj.Ref_id,
                            D_meeting_id: this.MeetingObj.id,
                            create_by: this.MeData[0].perid,
                            create_time: 'now()',
                          }, this.headerAxiosPUT)
                          this.dialogLoading = false
                          this.staffSel = ''
                          this.fetchJoinMeetData2()
                          this.$swal.fire({
                            icon: 'success',
                            title: 'รหัสบุคลากร ' + DataEmp[0].perid + ' : ' + DataEmp[0].full_Name + ' ลงทะเบียนเข้าร่วมประชุมสำเร็จ !!',
                            showConfirmButton: false,
                            timer: 700
                          })
                          setTimeout(() => {
                            if (this.$refs.staffSel && this.$refs.staffSel.$refs.input) {
                              this.$refs.staffSel.$refs.input.focus();
                            }
                          }, 1000)
                        } else {
                          this.dialogLoading = false
                          this.staffSel = ''
                          this.$swal.fire({
                            icon: 'error',
                            title: 'พบข้อผิดพลาด ไม่สามารถบันทึกข้อมูลผู้เข้าร่วมประชุมได้ โปรดติดต่อ ฝ่าย IT',
                            showConfirmButton: false,
                            timer: 700
                          })
                          setTimeout(() => {
                            if (this.$refs.staffSel && this.$refs.staffSel.$refs.input) {
                              this.$refs.staffSel.$refs.input.focus();
                            }
                          }, 1000)
                        }
                      })
                    } else {
                      this.dialogLoading = false
                      this.staffSel = ''
                      this.$swal.fire({
                        icon: 'error',
                        title: 'พบข้อผิดพลาด ไม่สามารถบันทึกข้อมูลผู้เข้าร่วมประชุมได้ โปรดติดต่อ ฝ่าย IT',
                        showConfirmButton: false,
                        timer: 700
                      })
                      setTimeout(() => {
                        if (this.$refs.staffSel && this.$refs.staffSel.$refs.input) {
                          this.$refs.staffSel.$refs.input.focus();
                        }
                      }, 1000)
                    }
                  }
                } else {
                  this.dialogLoading = false
                  this.staffSel = ''
                  this.$swal.fire({
                    icon: 'error',
                    title: 'ไม่พบข้อมูลรหัสบุคลากร',
                    showConfirmButton: false,
                    timer: 700
                  })
                  setTimeout(() => {
                    if (this.$refs.staffSel && this.$refs.staffSel.$refs.input) {
                      this.$refs.staffSel.$refs.input.focus();
                    }
                  }, 1000)
                }
              } else {
                this.dialogLoading = false
                this.staffSel = ''
                this.$swal.fire({
                  icon: 'error',
                  title: 'พบข้อมูลหมายเลขบัตรดังกล่าว ซํ้ากับผู้อื่น !!',
                  showConfirmButton: false,
                  timer: 700
                })
                setTimeout(() => {
                  if (this.$refs.staffSel && this.$refs.staffSel.$refs.input) {
                    this.$refs.staffSel.$refs.input.focus();
                  }
                }, 1000)
              }
            } else if (CardEmp.length == 1) {
              DataEmp = this.staffData.filter(item => item.perid == CardEmp[0].PERID)
              if (DataEmp.length > 0) {
                DataJoinEmp = this.JoinMeet.filter(item => item.uid == CardEmp[0].PERID)
                if (DataJoinEmp.length > 0) {
                  axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_meeting_join2/D_meeting_uuid/' + DataJoinEmp[0].D_meeting_uuid + '/uid/' + DataEmp[0].perid, {
                    // axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_meeting_join2/perid/' + DataEmp[0].perid, {
                    status_reg: '1',
                    update_by: this.MeData[0].perid,
                  }, this.headerAxios).then(async res => {
                    if (res.data.status) {
                      await axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/History_Experts/perid/' + DataEmp[0].perid + '/D_meeting_id/' + this.MeetingObj.id + '/?limit=1').then(async resHis => {
                        if (resHis.data) {
                          if (resHis.data.active == '0') {
                            await axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/History_Experts/id/' + resHis.data.id, {
                              active: '1',
                              update_by: this.MeData[0].perid,
                            }, this.headerAxios).then(resUpdate => {
                              if (resUpdate.data.status) {
                                this.dialogLoading = false
                                this.staffSel = ''
                                this.fetchJoinMeetData2()
                                this.$swal.fire({
                                  icon: 'success',
                                  title: 'รหัสบุคลากร ' + DataEmp[0].perid + ' : ' + DataEmp[0].full_Name + ' ลงทะเบียนเข้าร่วมประชุมสำเร็จ !!',
                                  showConfirmButton: false,
                                  timer: 700
                                })
                                setTimeout(() => {
                                  if (this.$refs.staffSel && this.$refs.staffSel.$refs.input) {
                                    this.$refs.staffSel.$refs.input.focus();
                                  }
                                }, 1000)
                              }
                            })
                          } else {
                            this.dialogLoading = false
                            this.staffSel = ''
                            this.fetchJoinMeetData2()
                            this.$swal.fire({
                              icon: 'success',
                              title: 'รหัสบุคลากร ' + DataEmp[0].perid + ' : ' + DataEmp[0].full_Name + ' ลงทะเบียนเข้าร่วมประชุมสำเร็จ !!',
                              showConfirmButton: false,
                              timer: 700
                            })
                            setTimeout(() => {
                              if (this.$refs.staffSel && this.$refs.staffSel.$refs.input) {
                                this.$refs.staffSel.$refs.input.focus();
                              }
                            }, 1000)
                          }
                        } else {
                          await axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/History_Experts/', {
                            perid: DataEmp[0].perid,
                            Project_code: '',
                            Project_name: '',
                            date_travel_start: '0000-00-00',
                            date_travel_end: '0000-00-00',
                            time_start: this.MeetingObj.Time_start,
                            time_end: this.MeetingObj.Time_end,
                            subject: this.MeetingObj.Topic,
                            type: '15',
                            date_start: this.MeetingObj.Date_start,
                            date_end: this.MeetingObj.Date_end,
                            Rm: this.MeetingObj.Rm,
                            Ref_id: this.MeetingObj.Ref_id,
                            D_meeting_id: this.MeetingObj.id,
                            create_by: this.MeData[0].perid,
                            create_time: 'now()',
                          }, this.headerAxiosPUT).then(resPut => {
                            if (resPut.data.status) {
                              this.dialogLoading = false
                              this.staffSel = ''
                              this.fetchJoinMeetData2()
                              this.$swal.fire({
                                icon: 'success',
                                title: 'รหัสบุคลากร ' + DataEmp[0].perid + ' : ' + DataEmp[0].full_Name + ' ลงทะเบียนเข้าร่วมประชุมสำเร็จ !!',
                                showConfirmButton: false,
                                timer: 700
                              })
                              setTimeout(() => {
                                if (this.$refs.staffSel && this.$refs.staffSel.$refs.input) {
                                  this.$refs.staffSel.$refs.input.focus();
                                }
                              }, 1000)
                            }
                          })
                        }
                      })
                    } else {
                      this.dialogLoading = false
                      this.staffSel = ''
                      this.$swal.fire({
                        icon: 'error',
                        title: 'ไม่พบข้อมูลรายชื่อผู้เข้าร่วมการประชุม',
                        showConfirmButton: false,
                        timer: 700
                      })
                      setTimeout(() => {
                        if (this.$refs.staffSel && this.$refs.staffSel.$refs.input) {
                          this.$refs.staffSel.$refs.input.focus();
                        }
                      }, 1000)
                    }
                  })
                } else {
                  /*axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_meeting_join2', {
                    perid: DataEmp[0].perid,
                    D_meeting_uuid: this.LinkGen,
                    status_reg: '1',
                    create_by: this.MeData[0].perid,
                    create_time: 'now()',
                  }, this.headerAxiosPUT).then(resJoinMeet => {*/
                  Staff = this.staffData.filter(item => item.perid == DataEmp[0].perid)
                  if (Staff.length > 0) {
                    axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_meeting_join2', {
                      status_reg: '1',
                      D_meeting_uuid: this.LinkGen,
                      uid: Staff[0].perid,
                      name: Staff[0].name,
                      sname: Staff[0].surname,
                      id_card: Staff[0].citizen_id,
                      affiliation: Staff[0].dep_name,
                      position: Staff[0].pos_name,
                      phone: '',
                      registerType_id: 0,
                      Create_By: this.MeData[0].perid,
                      Create_Time: 'now()',
                    }, this.headerAxiosPUT).then(resJoinMeet => {
                      if (resJoinMeet.status) {
                        axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/History_Experts/', {
                          perid: DataEmp[0].perid,
                          Project_code: '',
                          Project_name: '',
                          date_travel_start: '0000-00-00',
                          date_travel_end: '0000-00-00',
                          time_start: this.MeetingObj.Time_start,
                          time_end: this.MeetingObj.Time_end,
                          subject: this.MeetingObj.Topic,
                          type: '15',
                          date_start: this.MeetingObj.Date_start,
                          date_end: this.MeetingObj.Date_end,
                          Rm: this.MeetingObj.Rm,
                          Ref_id: this.MeetingObj.Ref_id,
                          D_meeting_id: this.MeetingObj.id,
                          create_by: this.MeData[0].perid,
                          create_time: 'now()',
                        }, this.headerAxiosPUT)
                        this.dialogLoading = false
                        this.staffSel = ''
                        this.fetchJoinMeetData2()
                        this.$swal.fire({
                          icon: 'success',
                          title: 'รหัสบุคลากร ' + DataEmp[0].perid + ' : ' + DataEmp[0].full_Name + ' ลงทะเบียนเข้าร่วมประชุมสำเร็จ !!',
                          showConfirmButton: false,
                          timer: 700
                        })
                        setTimeout(() => {
                          if (this.$refs.staffSel && this.$refs.staffSel.$refs.input) {
                            this.$refs.staffSel.$refs.input.focus();
                          }
                        }, 1000)
                      } else {
                        this.dialogLoading = false
                        this.staffSel = ''
                        this.$swal.fire({
                          icon: 'error',
                          title: 'พบข้อผิดพลาด ไม่สามารถบันทึกข้อมูลผู้เข้าร่วมประชุมได้ โปรดติดต่อ ฝ่าย IT',
                          showConfirmButton: false,
                          timer: 700
                        })
                        setTimeout(() => {
                          if (this.$refs.staffSel && this.$refs.staffSel.$refs.input) {
                            this.$refs.staffSel.$refs.input.focus();
                          }
                        }, 1000)
                      }
                    })
                  } else {
                    this.dialogLoading = false
                    this.staffSel = ''
                    this.$swal.fire({
                      icon: 'error',
                      title: 'พบข้อผิดพลาด ไม่สามารถบันทึกข้อมูลผู้เข้าร่วมประชุมได้ โปรดติดต่อ ฝ่าย IT',
                      showConfirmButton: false,
                      timer: 700
                    })
                    setTimeout(() => {
                      if (this.$refs.staffSel && this.$refs.staffSel.$refs.input) {
                        this.$refs.staffSel.$refs.input.focus();
                      }
                    }, 1000)
                  }
                }
              } else {
                this.dialogLoading = false
                this.staffSel = ''
                this.$swal.fire({
                  icon: 'error',
                  title: 'ไม่พบข้อมูลรหัสบุคลากร',
                  showConfirmButton: false,
                  timer: 700
                })
                setTimeout(() => {
                  if (this.$refs.staffSel && this.$refs.staffSel.$refs.input) {
                    this.$refs.staffSel.$refs.input.focus();
                  }
                }, 1000)
              }
            } else {
              this.getCardDataMedStudent({
                card_no: this.staffSel
              }).then(res => {
                if (res) {
                  if (this.CardData2.length > 0) {
                    this.Idstudent = this.CardData2[0].uid
                    this.staffSel = ''
                    this.insertStd('med')
                  } else {
                    this.dialogLoading = false
                    this.staffSel = ''
                    this.$swal.fire({
                      icon: 'error',
                      title: 'ไม่พบข้อมูลหมายเลข !!',
                      showConfirmButton: false,
                      timer: 700
                    })
                    setTimeout(() => {
                      if (this.$refs.staffSel && this.$refs.staffSel.$refs.input) {
                        this.$refs.staffSel.$refs.input.focus();
                      }
                    }, 1000)
                  }
                } else {
                  this.dialogLoading = false
                  this.staffSel = ''
                  this.$swal.fire({
                    icon: 'error',
                    title: 'ไม่พบข้อมูลหมายเลข !!',
                    showConfirmButton: false,
                    timer: 700
                  })
                  setTimeout(() => {
                    if (this.$refs.staffSel && this.$refs.staffSel.$refs.input) {
                      this.$refs.staffSel.$refs.input.focus();
                    }
                  }, 1000)
                }
              })
            }
          }
        }
      }
    }, //ปลดล็อคลงทะเบียนได้ทั้งหมด
    RegisterPerson() {
      this.CheckMeetigCordi = false
      this.dialogLoading = true
      if (this.staffSel == '') {
        this.dialogLoading = false
        this.$swal.fire({
          icon: 'error',
          title: 'โปรดสแกนบัตรบุคลากร หรือ กรอกข้อมูลรหัสบุคลากรก่อนทำการลงทะเบียน',
          showConfirmButton: false,
          timer: 700
        })
        setTimeout(() => {
          if (this.$refs.staffSel && this.$refs.staffSel.$refs.input) {
            this.$refs.staffSel.$refs.input.focus();
          }
        }, 1000)
      } else {
        if (this.MeetingCordiData.length > 0) {
          if (this.MeetingCordiData.filter(item => item.D_meeting_id == this.MeetingObj.id).length > 0) {
            if (this.staffSel && typeof this.staffSel === 'string') {
              // ตรวจสอบว่ามีตัวเลขหรือไม่
              const hasNumber = /\d/.test(this.staffSel);
              // ตรวจสอบว่ามีอักขระและตัวเลขรวมกันหรือไม่
              const hasLetter = /[a-zA-Zก-๙]/.test(this.staffSel);
              if (!hasNumber || (hasNumber && hasLetter)) {
                this.staffSel = '';
                this.dialogLoading = false;
                this.$swal.fire({
                  icon: 'error',
                  title: 'กรุณาเปลี่ยนภาษาบนคีย์บอร์ดเป็นภาษาอังกฤษก่อนสแกนหรือกรอกหมายเลข และห้ามมีอักขระกับตัวเลขรวมกัน',
                  showConfirmButton: false,
                  timer: 1500
                });
                setTimeout(() => {
                  if(this.joinTab == 0 && this.TypeRegStd == '0') {
                    if (this.$refs.staffSel && this.$refs.staffSel.$refs.input) {
                      this.$refs.staffSel.$refs.input.focus();
                    }
                  } else if(this.joinTab == 1 && this.TypeRegStd == '1') {
                    if (this.$refs.Idstudent && this.$refs.Idstudent.$refs.input) {
                      this.$refs.Idstudent.$refs.input.focus();
                    }
                  }
                }, 1000);
                return;
              }
            }
            if (this.staffSel && typeof this.staffSel === 'string') {
              // แปลงอักษรภาษาอังกฤษและไทยที่อยู่บนแป้นพิมพ์ตัวเลขกลับเป็นตัวเลข
              const keyMap = {
                'q': '1', 'Q': '1', 'ๅ': '1',
                'w': '2', 'W': '2', '/': '2',
                'e': '3', 'E': '3', 'ภ': '3',
                'r': '4', 'R': '4', 'ถ': '4',
                't': '5', 'T': '5', 'ุ': '5',
                'y': '6', 'Y': '6', 'ึ': '6',
                'u': '7', 'U': '7', 'ค': '7',
                'i': '8', 'I': '8', 'ต': '8',
                'o': '9', 'O': '9', 'จ': '9',
                'p': '0', 'P': '0', 'ข': '0'
              };
              let converted = '';
              for (let ch of this.staffSel) {
                if (keyMap[ch]) {
                  converted += keyMap[ch];
                } else if (/\d/.test(ch)) {
                  converted += ch;
                }
                // ถ้าเป็นอักขระอื่นๆ ให้ข้าม
              }
              this.staffSel = converted;
            }
            if (this.staffSel.length <= 5) {
              var DataEmp = this.staffData.filter(item => item.perid == this.staffSel)
              if (DataEmp.length > 0) {
                var DataJoinEmp = this.JoinMeet.filter(item => item.uid == this.staffSel)
                if (DataJoinEmp.length == 0) {
                  this.dialogLoading = false
                  this.CheckMeetigCordi = true
                  this.staffSel = ''
                  this.$swal.fire({
                    icon: 'error',
                    title: 'ไม่สามารถลงทะเบียนได้เนื่องจากไม่พบรายชื่อผู้เข้าร่วม',
                    showConfirmButton: false,
                    timer: 700
                  })
                  setTimeout(() => {
                    if (this.$refs.staffSel && this.$refs.staffSel.$refs.input) {
                      this.$refs.staffSel.$refs.input.focus();
                    }
                  }, 1000)
                }
              } else {
                this.dialogLoading = false
                this.CheckMeetigCordi = true
                this.staffSel = ''
                this.$swal.fire({
                  icon: 'error',
                  title: 'ไม่พบข้อมูลรหัสบุคลากร',
                  showConfirmButton: false,
                  timer: 700
                })
                setTimeout(() => {
                  if (this.$refs.staffSel && this.$refs.staffSel.$refs.input) {
                    this.$refs.staffSel.$refs.input.focus();
                  }
                }, 1000)
              }
            } else {
              var CardEmp = this.CardData.filter(item => item.CARD_NO == ('' + parseInt(this.staffSel)))
              if (CardEmp.length > 0) {
                CardEmp = this.UniqueArraybyId(CardEmp, 'PERID')
                if (CardEmp.length == 1) {
                  DataEmp = this.staffData.filter(item => item.perid == CardEmp[0].PERID)
                  if (DataEmp.length > 0) {
                    DataJoinEmp = this.JoinMeet.filter(item => item.uid == CardEmp[0].PERID)
                    if (DataJoinEmp.length == 0) {
                      this.dialogLoading = false
                      this.CheckMeetigCordi = true
                      this.staffSel = ''
                      this.$swal.fire({
                        icon: 'error',
                        title: 'ไม่สามารถลงทะเบียนได้เนื่องจากไม่พบรายชื่อผู้เข้าร่วม',
                        showConfirmButton: false,
                        timer: 700
                      })
                      setTimeout(() => {
                        if (this.$refs.staffSel && this.$refs.staffSel.$refs.input) {
                          this.$refs.staffSel.$refs.input.focus();
                        }
                      }, 1000)
                    }
                  } else {
                    this.dialogLoading = false
                    this.CheckMeetigCordi = true
                    this.staffSel = ''
                    this.$swal.fire({
                      icon: 'error',
                      title: 'ไม่พบข้อมูลรหัสบุคลากร',
                      showConfirmButton: false,
                      timer: 700
                    })
                    setTimeout(() => {
                      if (this.$refs.staffSel && this.$refs.staffSel.$refs.input) {
                        this.$refs.staffSel.$refs.input.focus();
                      }
                    }, 1000)
                  }
                } else {
                  this.dialogLoading = false
                  this.CheckMeetigCordi = true
                  this.staffSel = ''
                  this.$swal.fire({
                    icon: 'error',
                    title: 'พบข้อมูลหมายเลขบัตรดังกล่าว ซํ้ากับผู้อื่น !!',
                    showConfirmButton: false,
                    timer: 700
                  })
                  setTimeout(() => {
                    if (this.$refs.staffSel && this.$refs.staffSel.$refs.input) {
                      this.$refs.staffSel.$refs.input.focus();
                    }
                  }, 1000)
                }
              } else {
                this.getCardDataMedStudent({
                  card_no: this.staffSel
                }).then(res => {
                  if (res) {
                    if (this.CardData2.length > 0) {
                      this.Idstudent = this.CardData2[0].uid
                      this.staffSel = ''
                      this.insertStd('med')
                    } else {
                      this.dialogLoading = false
                      this.CheckMeetigCordi = true
                      this.staffSel = ''
                      this.$swal.fire({
                        icon: 'error',
                        title: 'ไม่พบข้อมูลหมายเลข !!',
                        showConfirmButton: false,
                        timer: 700
                      })
                      setTimeout(() => {
                        if (this.$refs.staffSel && this.$refs.staffSel.$refs.input) {
                          this.$refs.staffSel.$refs.input.focus();
                        }
                      }, 1000)
                    }
                  } else {
                    this.dialogLoading = false
                    this.CheckMeetigCordi = true
                    this.staffSel = ''
                    this.$swal.fire({
                      icon: 'error',
                      title: 'ไม่พบข้อมูลหมายเลข !!',
                      showConfirmButton: false,
                      timer: 700
                    })
                    setTimeout(() => {
                      if (this.$refs.staffSel && this.$refs.staffSel.$refs.input) {
                        this.$refs.staffSel.$refs.input.focus();
                      }
                    }, 1000)
                  }
                })
              }
            }
          }
        }
        if (!this.CheckMeetigCordi) {
          if (this.staffSel && typeof this.staffSel === 'string') {
            // ตรวจสอบว่ามีตัวเลขหรือไม่
            const hasNumber = /\d/.test(this.staffSel);
            // ตรวจสอบว่ามีอักขระและตัวเลขรวมกันหรือไม่
            const hasLetter = /[a-zA-Zก-๙]/.test(this.staffSel);
            if (!hasNumber || (hasNumber && hasLetter)) {
              this.staffSel = ''
              this.dialogLoading = false;
              this.$swal.fire({
                icon: 'error',
                title: 'กรุณาเปลี่ยนภาษาบนคีย์บอร์ดเป็นภาษาอังกฤษก่อนสแกนหรือกรอกหมายเลข และห้ามมีอักขระกับตัวเลขรวมกัน',
                showConfirmButton: false,
                timer: 1500
              });
              setTimeout(() => {
                if(this.joinTab == 0 && this.TypeRegStd == '0') {
                  if (this.$refs.staffSel && this.$refs.staffSel.$refs.input) {
                    this.$refs.staffSel.$refs.input.focus();
                  }
                } else if(this.joinTab == 1 && this.TypeRegStd == '1') {
                  if (this.$refs.Idstudent && this.$refs.Idstudent.$refs.input) {
                    this.$refs.Idstudent.$refs.input.focus();
                  }
                }
              }, 1000);
              return;
            }
          }
          if (this.staffSel && typeof this.staffSel === 'string') {
            // แปลงอักษรภาษาอังกฤษและไทยที่อยู่บนแป้นพิมพ์ตัวเลขกลับเป็นตัวเลข
            const keyMap = {
              'q': '1', 'Q': '1', 'ๅ': '1',
              'w': '2', 'W': '2', '/': '2',
              'e': '3', 'E': '3', 'ภ': '3',
              'r': '4', 'R': '4', 'ถ': '4',
              't': '5', 'T': '5', 'ุ': '5',
              'y': '6', 'Y': '6', 'ึ': '6',
              'u': '7', 'U': '7', 'ค': '7',
              'i': '8', 'I': '8', 'ต': '8',
              'o': '9', 'O': '9', 'จ': '9',
              'p': '0', 'P': '0', 'ข': '0'
            };
            let converted = '';
            for (let ch of this.staffSel) {
              if (keyMap[ch]) {
                converted += keyMap[ch];
              } else if (/\d/.test(ch)) {
                converted += ch;
              }
              // ถ้าเป็นอักขระอื่นๆ ให้ข้าม
            }
            this.staffSel = converted;
          }
          if (this.staffSel.length <= 5) {
            DataEmp = this.staffData.filter(item => item.perid == this.staffSel)
            if (DataEmp.length > 0) {
              DataJoinEmp = this.JoinMeet.filter(item => item.uid == this.staffSel)
              if (DataJoinEmp.length > 0) {
                axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_meeting_join2/D_meeting_uuid/' + DataJoinEmp[0].D_meeting_uuid + '/uid/' + this.staffSel, {
                  // axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_meeting_join2/perid/' + this.staffSel, {
                  status_reg: '1',
                  update_by: this.MeData[0].perid,
                }, this.headerAxios).then(async res => {
                  if (res.data.status) {
                    await axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/History_Experts/perid/' + this.staffSel + '/D_meeting_id/' + this.MeetingObj.id + '/?limit=1').then(async resHis => {
                      if (resHis.data) {
                        if (resHis.data.active == '0') {
                          await axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/History_Experts/id/' + resHis.data.id, {
                            active: '1',
                            update_by: this.MeData[0].perid,
                          }, this.headerAxios).then(resUpdate => {
                            if (resUpdate.data.status) {
                              this.dialogLoading = false
                              this.staffSel = ''
                              this.fetchJoinMeetData2()
                              this.$swal.fire({
                                icon: 'success',
                                title: 'รหัสบุคลากร ' + DataEmp[0].perid + ' : ' + DataEmp[0].full_Name + ' ลงทะเบียนเข้าร่วมประชุมสำเร็จ !!',
                                showConfirmButton: false,
                                timer: 700
                              })
                              setTimeout(() => {
                                if (this.$refs.staffSel && this.$refs.staffSel.$refs.input) {
                                  this.$refs.staffSel.$refs.input.focus();
                                }
                              }, 1000)
                            }
                          })
                        } else {
                          this.dialogLoading = false
                          this.staffSel = ''
                          this.fetchJoinMeetData2()
                          this.$swal.fire({
                            icon: 'success',
                            title: 'รหัสบุคลากร ' + DataEmp[0].perid + ' : ' + DataEmp[0].full_Name + ' ลงทะเบียนเข้าร่วมประชุมสำเร็จ !!',
                            showConfirmButton: false,
                            timer: 700
                          })
                          setTimeout(() => {
                            if (this.$refs.staffSel && this.$refs.staffSel.$refs.input) {
                              this.$refs.staffSel.$refs.input.focus();
                            }
                          }, 1000)
                        }
                      } else {
                        await axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/History_Experts/', {
                          perid: this.staffSel,
                          Project_code: '',
                          Project_name: '',
                          date_travel_start: '0000-00-00',
                          date_travel_end: '0000-00-00',
                          time_start: this.MeetingObj.Time_start,
                          time_end: this.MeetingObj.Time_end,
                          subject: this.MeetingObj.Topic,
                          type: '15',
                          date_start: this.MeetingObj.Date_start,
                          date_end: this.MeetingObj.Date_end,
                          Rm: this.MeetingObj.Rm,
                          Ref_id: this.MeetingObj.Ref_id,
                          D_meeting_id: this.MeetingObj.id,
                          create_by: this.MeData[0].perid,
                          create_time: 'now()',
                        }, this.headerAxiosPUT).then(resPut => {
                          if (resPut.data.status) {
                            this.dialogLoading = false
                            this.staffSel = ''
                            this.fetchJoinMeetData2()
                            this.$swal.fire({
                              icon: 'success',
                              title: 'รหัสบุคลากร ' + DataEmp[0].perid + ' : ' + DataEmp[0].full_Name + ' ลงทะเบียนเข้าร่วมประชุมสำเร็จ !!',
                              showConfirmButton: false,
                              timer: 700
                            })
                            setTimeout(() => {
                              if (this.$refs.staffSel && this.$refs.staffSel.$refs.input) {
                                this.$refs.staffSel.$refs.input.focus();
                              }
                            }, 1000)
                          }
                        })
                      }
                    })
                  } else {
                    this.dialogLoading = false
                    this.staffSel = ''
                    this.$swal.fire({
                      icon: 'error',
                      title: 'พบข้อผิดพลาด ไม่สามารถบันทึกข้อมูลผู้เข้าร่วมประชุมได้ โปรดติดต่อ ฝ่าย IT',
                      showConfirmButton: false,
                      timer: 700
                    })
                    setTimeout(() => {
                      if (this.$refs.staffSel && this.$refs.staffSel.$refs.input) {
                        this.$refs.staffSel.$refs.input.focus();
                      }
                    }, 1000)
                  }
                })
              } else {
                this.dialogLoading = false
                this.staffSel = ''
                this.$swal.fire({
                  icon: 'error',
                  title: DataEmp[0].full_Name + ' (' + DataEmp[0].perid + ') ไม่สามารถเข้าร่วมประชุมได้เนื่องจาก ไม่พบข้อมูลผู้เข้าร่วมประชุม',
                  showConfirmButton: false,
                  timer: 700
                })
                setTimeout(() => {
                  if (this.$refs.staffSel && this.$refs.staffSel.$refs.input) {
                    this.$refs.staffSel.$refs.input.focus();
                  }
                }, 1000)
                // ปลดล็อคลงทะบเียนได้ทุกคน
                /*axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_meeting_join2', {
                  perid: this.staffSel,
                  D_meeting_uuid: this.LinkGen,
                  status_reg: '1',
                  create_by: this.MeData[0].perid,
                  create_time: 'now()',
                }, this.headerAxiosPUT).then(resJoinMeet => {
                  if (resJoinMeet.status) {
                    axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/History_Experts/', {
                      perid: this.staffSel,
                      Project_code: '',
                      Project_name: '',
                      date_travel_start: '0000-00-00',
                      date_travel_end: '0000-00-00',
                      time_start: this.MeetingObj.Time_start,
                      time_end: this.MeetingObj.Time_end,
                      subject: this.MeetingObj.Topic,
                      type: '15',
                      date_start: this.MeetingObj.Date_start,
                      date_end: this.MeetingObj.Date_end,
                      Rm: this.MeetingObj.Rm,
                      Ref_id: this.MeetingObj.Ref_id,
                      D_meeting_id: this.MeetingObj.id,
                      create_by: this.MeData[0].perid,
                      create_time: 'now()',
                    }, this.headerAxiosPUT)
                    this.staffSel = ''
                    this.fetchJoinMeetData2()
                    this.$swal.fire({
                      icon: 'success',
                      title: 'รหัสบุคลากร ' + DataEmp[0].perid + ' : ' + DataEmp[0].full_Name + ' ลงทะเบียนเข้าร่วมประชุมสำเร็จ !!',
                      showConfirmButton: false,
                      timer: 700
                    })
                  } else {
                    this.staffSel = ''
                    this.$swal.fire({
                      icon: 'error',
                      title: 'พบข้อผิดพลาด ไม่สามารถบันทึกข้อมูลผู้เข้าร่วมประชุมได้ โปรดติดต่อ ฝ่าย IT',
                      showConfirmButton: false,
                      timer: 700
                    })
                  }
                })*/
              }
            } else {
              this.dialogLoading = false
              this.staffSel = ''
              this.$swal.fire({
                icon: 'error',
                title: 'ไม่พบข้อมูลรหัสบุคลากร',
                showConfirmButton: false,
                timer: 700
              })
              setTimeout(() => {
                if (this.$refs.staffSel && this.$refs.staffSel.$refs.input) {
                  this.$refs.staffSel.$refs.input.focus();
                }
              }, 1000)
            }
          } else {
            CardEmp = this.CardData.filter(item => item.CARD_NO == ('' + parseInt(this.staffSel)))
            if (CardEmp.length > 1) {
              CardEmp = this.UniqueArraybyId(CardEmp, 'PERID')
              if (CardEmp.length == 1) {
                DataEmp = this.staffData.filter(item => item.perid == CardEmp[0].PERID)
                if (DataEmp.length > 0) {
                  DataJoinEmp = this.JoinMeet.filter(item => item.uid == CardEmp[0].PERID)
                  if (DataJoinEmp.length > 0) {
                    axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_meeting_join2/D_meeting_uuid/' + DataJoinEmp[0].D_meeting_uuid + '/uid/' + DataEmp[0].perid, {
                      // axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_meeting_join2/perid/' + DataEmp[0].perid, {
                      status_reg: '1',
                      update_by: this.MeData[0].perid,
                    }, this.headerAxios).then(async res => {
                      if (res.data.status) {
                        await axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/History_Experts/perid/' + DataEmp[0].perid + '/D_meeting_id/' + this.MeetingObj.id + '/?limit=1').then(async resHis => {
                          if (resHis.data) {
                            if (resHis.data.active == '0') {
                              await axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/History_Experts/id/' + resHis.data.id, {
                                active: '1',
                                update_by: this.MeData[0].perid,
                              }, this.headerAxios).then(resUpdate => {
                                if (resUpdate.data.status) {
                                  this.dialogLoading = false
                                  this.staffSel = ''
                                  this.fetchJoinMeetData2()
                                  this.$swal.fire({
                                    icon: 'success',
                                    title: 'รหัสบุคลากร ' + DataEmp[0].perid + ' : ' + DataEmp[0].full_Name + ' ลงทะเบียนเข้าร่วมประชุมสำเร็จ !!',
                                    showConfirmButton: false,
                                    timer: 700
                                  })
                                  setTimeout(() => {
                                    if (this.$refs.staffSel && this.$refs.staffSel.$refs.input) {
                                      this.$refs.staffSel.$refs.input.focus();
                                    }
                                  }, 1000)
                                }
                              })
                            } else {
                              this.dialogLoading = false
                              this.staffSel = ''
                              this.fetchJoinMeetData2()
                              this.$swal.fire({
                                icon: 'success',
                                title: 'รหัสบุคลากร ' + DataEmp[0].perid + ' : ' + DataEmp[0].full_Name + ' ลงทะเบียนเข้าร่วมประชุมสำเร็จ !!',
                                showConfirmButton: false,
                                timer: 700
                              })
                              setTimeout(() => {
                                if (this.$refs.staffSel && this.$refs.staffSel.$refs.input) {
                                  this.$refs.staffSel.$refs.input.focus();
                                }
                              }, 1000)
                            }
                          } else {
                            await axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/History_Experts/', {
                              perid: DataEmp[0].perid,
                              Project_code: '',
                              Project_name: '',
                              date_travel_start: '0000-00-00',
                              date_travel_end: '0000-00-00',
                              time_start: this.MeetingObj.Time_start,
                              time_end: this.MeetingObj.Time_end,
                              subject: this.MeetingObj.Topic,
                              type: '15',
                              date_start: this.MeetingObj.Date_start,
                              date_end: this.MeetingObj.Date_end,
                              Rm: this.MeetingObj.Rm,
                              Ref_id: this.MeetingObj.Ref_id,
                              D_meeting_id: this.MeetingObj.id,
                              create_by: this.MeData[0].perid,
                              create_time: 'now()',
                            }, this.headerAxiosPUT).then(resPut => {
                              if (resPut.data.status) {
                                this.dialogLoading = false
                                this.staffSel = ''
                                this.fetchJoinMeetData2()
                                this.$swal.fire({
                                  icon: 'success',
                                  title: 'รหัสบุคลากร ' + DataEmp[0].perid + ' : ' + DataEmp[0].full_Name + ' ลงทะเบียนเข้าร่วมประชุมสำเร็จ !!',
                                  showConfirmButton: false,
                                  timer: 700
                                })
                                setTimeout(() => {
                                  if (this.$refs.staffSel && this.$refs.staffSel.$refs.input) {
                                    this.$refs.staffSel.$refs.input.focus();
                                  }
                                }, 1000)
                              }
                            })
                          }
                        })
                      } else {
                        this.dialogLoading = false
                        this.staffSel = ''
                        this.$swal.fire({
                          icon: 'error',
                          title: 'ไม่พบข้อมูลรายชื่อผู้เข้าร่วมการประชุม',
                          showConfirmButton: false,
                          timer: 700
                        })
                        setTimeout(() => {
                          if (this.$refs.staffSel && this.$refs.staffSel.$refs.input) {
                            this.$refs.staffSel.$refs.input.focus();
                          }
                        }, 1000)
                      }
                    })
                  } else {
                    this.dialogLoading = false
                    this.staffSel = ''
                    this.$swal.fire({
                      icon: 'error',
                      title: DataEmp[0].full_Name + ' (' + DataEmp[0].perid + ') ไม่สามารถเข้าร่วมประชุมได้เนื่องจาก ไม่พบข้อมูลผู้เข้าร่วมประชุม',
                      showConfirmButton: false,
                      timer: 700
                    })
                    setTimeout(() => {
                      if (this.$refs.staffSel && this.$refs.staffSel.$refs.input) {
                        this.$refs.staffSel.$refs.input.focus();
                      }
                    }, 1000)
                    //ปล็คล็อคลงทะเบียนได้ทุกคน
                    /*axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_meeting_join2', {
                      perid: DataEmp[0].perid,
                      D_meeting_uuid: this.LinkGen,
                      status_reg: '1',
                      create_by: this.MeData[0].perid,
                      create_time: 'now()',
                    }, this.headerAxiosPUT).then(resJoinMeet => {
                      if (resJoinMeet.status) {
                        axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/History_Experts/', {
                          perid: DataEmp[0].perid,
                          Project_code: '',
                          Project_name: '',
                          date_travel_start: '0000-00-00',
                          date_travel_end: '0000-00-00',
                          time_start: this.MeetingObj.Time_start,
                          time_end: this.MeetingObj.Time_end,
                          subject: this.MeetingObj.Topic,
                          type: '15',
                          date_start: this.MeetingObj.Date_start,
                          date_end: this.MeetingObj.Date_end,
                          Rm: this.MeetingObj.Rm,
                          Ref_id: this.MeetingObj.Ref_id,
                          D_meeting_id: this.MeetingObj.id,
                          create_by: this.MeData[0].perid,
                          create_time: 'now()',
                        }, this.headerAxiosPUT)
                        this.staffSel = ''
                        this.fetchJoinMeetData2()
                        this.$swal.fire({
                          icon: 'success',
                          title: 'รหัสบุคลากร ' + DataEmp[0].perid + ' : ' + DataEmp[0].full_Name + ' ลงทะเบียนเข้าร่วมประชุมสำเร็จ !!',
                          showConfirmButton: false,
                          timer: 700
                        })
                      } else {
                        this.staffSel = ''
                        this.$swal.fire({
                          icon: 'error',
                          title: 'พบข้อผิดพลาด ไม่สามารถบันทึกข้อมูลผู้เข้าร่วมประชุมได้ โปรดติดต่อ ฝ่าย IT',
                          showConfirmButton: false,
                          timer: 700
                        })
                      }
                    })*/
                  }
                } else {
                  this.dialogLoading = false
                  this.staffSel = ''
                  this.$swal.fire({
                    icon: 'error',
                    title: 'ไม่พบข้อมูลรหัสบุคลากร',
                    showConfirmButton: false,
                    timer: 700
                  })
                  setTimeout(() => {
                    if (this.$refs.staffSel && this.$refs.staffSel.$refs.input) {
                      this.$refs.staffSel.$refs.input.focus();
                    }
                  }, 1000)
                }
              } else {
                this.dialogLoading = false
                this.staffSel = ''
                this.$swal.fire({
                  icon: 'error',
                  title: 'พบข้อมูลหมายเลขบัตรดังกล่าว ซํ้ากับผู้อื่น !!',
                  showConfirmButton: false,
                  timer: 700
                })
                setTimeout(() => {
                  if (this.$refs.staffSel && this.$refs.staffSel.$refs.input) {
                    this.$refs.staffSel.$refs.input.focus();
                  }
                }, 1000)
              }
            } else if (CardEmp.length == 1) {
              DataEmp = this.staffData.filter(item => item.perid == CardEmp[0].PERID)
              if (DataEmp.length > 0) {
                DataJoinEmp = this.JoinMeet.filter(item => item.uid == CardEmp[0].PERID)
                if (DataJoinEmp.length > 0) {
                  axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_meeting_join2/D_meeting_uuid/' + DataJoinEmp[0].D_meeting_uuid + '/uid/' + DataEmp[0].perid, {
                    // axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_meeting_join2/perid/' + DataEmp[0].perid, {
                    status_reg: '1',
                    update_by: this.MeData[0].perid,
                  }, this.headerAxios).then(async res => {
                    if (res.data.status) {
                      await axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/History_Experts/perid/' + DataEmp[0].perid + '/D_meeting_id/' + this.MeetingObj.id + '/?limit=1').then(async resHis => {
                        if (resHis.data) {
                          if (resHis.data.active == '0') {
                            await axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/History_Experts/id/' + resHis.data.id, {
                              active: '1',
                              update_by: this.MeData[0].perid,
                            }, this.headerAxios).then(resUpdate => {
                              if (resUpdate.data.status) {
                                this.dialogLoading = false
                                this.staffSel = ''
                                this.fetchJoinMeetData2()
                                this.$swal.fire({
                                  icon: 'success',
                                  title: 'รหัสบุคลากร ' + DataEmp[0].perid + ' : ' + DataEmp[0].full_Name + ' ลงทะเบียนเข้าร่วมประชุมสำเร็จ !!',
                                  showConfirmButton: false,
                                  timer: 700
                                })
                                setTimeout(() => {
                                  if (this.$refs.staffSel && this.$refs.staffSel.$refs.input) {
                                    this.$refs.staffSel.$refs.input.focus();
                                  }
                                }, 1000)
                              }
                            })
                          } else {
                            this.dialogLoading = false
                            this.staffSel = ''
                            this.fetchJoinMeetData2()
                            this.$swal.fire({
                              icon: 'success',
                              title: 'รหัสบุคลากร ' + DataEmp[0].perid + ' : ' + DataEmp[0].full_Name + ' ลงทะเบียนเข้าร่วมประชุมสำเร็จ !!',
                              showConfirmButton: false,
                              timer: 700
                            })
                            setTimeout(() => {
                              if (this.$refs.staffSel && this.$refs.staffSel.$refs.input) {
                                this.$refs.staffSel.$refs.input.focus();
                              }
                            }, 1000)
                          }
                        } else {
                          await axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/History_Experts/', {
                            perid: DataEmp[0].perid,
                            Project_code: '',
                            Project_name: '',
                            date_travel_start: '0000-00-00',
                            date_travel_end: '0000-00-00',
                            time_start: this.MeetingObj.Time_start,
                            time_end: this.MeetingObj.Time_end,
                            subject: this.MeetingObj.Topic,
                            type: '15',
                            date_start: this.MeetingObj.Date_start,
                            date_end: this.MeetingObj.Date_end,
                            Rm: this.MeetingObj.Rm,
                            Ref_id: this.MeetingObj.Ref_id,
                            D_meeting_id: this.MeetingObj.id,
                            create_by: this.MeData[0].perid,
                            create_time: 'now()',
                          }, this.headerAxiosPUT).then(resPut => {
                            if (resPut.data.status) {
                              this.dialogLoading = false
                              this.staffSel = ''
                              this.fetchJoinMeetData2()
                              this.$swal.fire({
                                icon: 'success',
                                title: 'รหัสบุคลากร ' + DataEmp[0].perid + ' : ' + DataEmp[0].full_Name + ' ลงทะเบียนเข้าร่วมประชุมสำเร็จ !!',
                                showConfirmButton: false,
                                timer: 700
                              })
                              setTimeout(() => {
                                if (this.$refs.staffSel && this.$refs.staffSel.$refs.input) {
                                  this.$refs.staffSel.$refs.input.focus();
                                }
                              }, 1000)
                            }
                          })
                        }
                      })
                    } else {
                      this.dialogLoading = false
                      this.staffSel = ''
                      this.$swal.fire({
                        icon: 'error',
                        title: 'ไม่พบข้อมูลรายชื่อผู้เข้าร่วมการประชุม',
                        showConfirmButton: false,
                        timer: 700
                      })
                      setTimeout(() => {
                        if (this.$refs.staffSel && this.$refs.staffSel.$refs.input) {
                          this.$refs.staffSel.$refs.input.focus();
                        }
                      }, 1000)
                    }
                  })
                } else {
                  this.dialogLoading = false
                  this.staffSel = ''
                  this.$swal.fire({
                    icon: 'error',
                    title: DataEmp[0].full_Name + ' (' + DataEmp[0].perid + ') ไม่สามารถเข้าร่วมประชุมได้เนื่องจาก ไม่พบข้อมูลผู้เข้าร่วมประชุม',
                    showConfirmButton: false,
                    timer: 700
                  })
                  setTimeout(() => {
                    if (this.$refs.staffSel && this.$refs.staffSel.$refs.input) {
                      this.$refs.staffSel.$refs.input.focus();
                    }
                  }, 1000)

                  //ปลดล็อคลงทะเบียนได้ทั้งหมด
                  /*axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_meeting_join2', {
                    perid: DataEmp[0].perid,
                    D_meeting_uuid: this.LinkGen,
                    status_reg: '1',
                    create_by: this.MeData[0].perid,
                    create_time: 'now()',
                  }, this.headerAxiosPUT).then(resJoinMeet => {
                    if (resJoinMeet.status) {
                      axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/History_Experts/', {
                        perid: DataEmp[0].perid,
                        Project_code: '',
                        Project_name: '',
                        date_travel_start: '0000-00-00',
                        date_travel_end: '0000-00-00',
                        time_start: this.MeetingObj.Time_start,
                        time_end: this.MeetingObj.Time_end,
                        subject: this.MeetingObj.Topic,
                        type: '15',
                        date_start: this.MeetingObj.Date_start,
                        date_end: this.MeetingObj.Date_end,
                        Rm: this.MeetingObj.Rm,
                        Ref_id: this.MeetingObj.Ref_id,
                        D_meeting_id: this.MeetingObj.id,
                        create_by: this.MeData[0].perid,
                        create_time: 'now()',
                      }, this.headerAxiosPUT)
                      this.staffSel = ''
                      this.fetchJoinMeetData2()
                      this.$swal.fire({
                        icon: 'success',
                        title: 'รหัสบุคลากร ' + DataEmp[0].perid + ' : ' + DataEmp[0].full_Name + ' ลงทะเบียนเข้าร่วมประชุมสำเร็จ !!',
                        showConfirmButton: false,
                        timer: 700
                      })
                    } else {
                      this.staffSel = ''
                      this.$swal.fire({
                        icon: 'error',
                        title: 'พบข้อผิดพลาด ไม่สามารถบันทึกข้อมูลผู้เข้าร่วมประชุมได้ โปรดติดต่อ ฝ่าย IT',
                        showConfirmButton: false,
                        timer: 700
                      })
                    }
                  })*/
                }
              } else {
                this.dialogLoading = false
                this.staffSel = ''
                this.$swal.fire({
                  icon: 'error',
                  title: 'ไม่พบข้อมูลรหัสบุคลากร',
                  showConfirmButton: false,
                  timer: 700
                })
                setTimeout(() => {
                  if (this.$refs.staffSel && this.$refs.staffSel.$refs.input) {
                    this.$refs.staffSel.$refs.input.focus();
                  }
                }, 1000)
              }
            } else {
              this.getCardDataMedStudent({
                card_no: this.staffSel
              }).then(res => {
                if (res) {
                  if (this.CardData2.length > 0) {
                    this.Idstudent = this.CardData2[0].uid
                    this.staffSel = ''
                    this.insertStd('med').then(res => {
                      if (res) {
                        setTimeout(() => {
                          if (this.$refs.staffSel && this.$refs.staffSel.$refs.input) {
                            this.$refs.staffSel.$refs.input.focus();
                          }
                        }, 1000)
                      }
                    })
                  } else {
                    this.dialogLoading = false
                    this.staffSel = ''
                    this.$swal.fire({
                      icon: 'error',
                      title: 'ไม่พบข้อมูลหมายเลข !!',
                      showConfirmButton: false,
                      timer: 700
                    })
                    setTimeout(() => {
                      if (this.$refs.staffSel && this.$refs.staffSel.$refs.input) {
                        this.$refs.staffSel.$refs.input.focus();
                      }
                    }, 1000)
                  }
                } else {
                  this.dialogLoading = false
                  this.staffSel = ''
                  this.$swal.fire({
                    icon: 'error',
                    title: 'ไม่พบข้อมูลหมายเลข !!',
                    showConfirmButton: false,
                    timer: 700
                  })
                  setTimeout(() => {
                    if (this.$refs.staffSel && this.$refs.staffSel.$refs.input) {
                      this.$refs.staffSel.$refs.input.focus();
                    }
                  }, 1000)
                }
              })
            }
          }
        }
      }
    },
    RegisterAll(status) {
      this.$swal.fire({
        title: 'ยืนยันการทำรายการ',
        text: "คุณต้องการ " + (status == '1' ? 'ยืนยันการลงทะเบียนผู้เข้าร่วมทั้งหมด' : 'ยกเลิกการลงทะเบียนผู้เข้าร่วมทั้งหมด') + ' ใช่หรือไม่ ?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.value) {
          this.dialogLoading = true
          var count = 0
          this.JoinMeet.map(item => {
            axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_meeting_join2/D_meeting_uuid/' + item.D_meeting_uuid + '/uid/' + item.uid, {
              // axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_meeting_join2/perid/' + item.perid, {
              status_reg: status,
              update_by: this.MeData[0].perid,
            }, this.headerAxios).then(async res => {
              item.status_reg = status
              if (res.data.status) {
                if (parseInt(item.registerType_id) == 0) {
                  if (status == '1') {
                    await axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/History_Experts/perid/' + item.uid + '/D_meeting_id/' + this.MeetingObj.id + '/?limit=1').then(async resHis => {
                      if (resHis.data) {
                        if (resHis.data.active == '0') {
                          await axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/History_Experts/id/' + resHis.data.id, {
                            active: '1',
                            update_by: this.MeData[0].perid,
                          }, this.headerAxios).then(resUpdate => {
                            count++
                            if (resUpdate.data.status) {
                              if (count == this.JoinMeet.length) {
                                this.dialogLoading = false
                                this.$swal.fire({
                                  icon: 'success',
                                  title: status == '1' ? 'ผู้เข้าร่วมโครงการทั้งหมดได้ทำการลงทะเบียนเข้าร่วมโครงการสำเร็จ!!' : 'ผู้เข้าร่วมโครงการทั้งหมดได้ยกเลิกการลงทะเบียนเข้าร่วมโครงการสำเร็จ!!',
                                  showConfirmButton: false,
                                  timer: 700
                                })
                              }
                            } else {
                              if (count == this.JoinMeet.length) {
                                this.dialogLoading = false
                                this.$swal.fire({
                                  icon: 'success',
                                  title: status == '1' ? 'ผู้เข้าร่วมโครงการทั้งหมดได้ทำการลงทะเบียนเข้าร่วมโครงการสำเร็จ!!' : 'ผู้เข้าร่วมโครงการทั้งหมดได้ยกเลิกการลงทะเบียนเข้าร่วมโครงการสำเร็จ!!',
                                  showConfirmButton: false,
                                  timer: 700
                                })
                              }
                            }
                          })
                        }
                      } else {
                        await axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/History_Experts/', {
                          perid: item.uid,
                          Project_code: '',
                          Project_name: '',
                          date_travel_start: '0000-00-00',
                          date_travel_end: '0000-00-00',
                          time_start: this.MeetingObj.Time_start,
                          time_end: this.MeetingObj.Time_end,
                          subject: this.MeetingObj.Topic,
                          type: '15',
                          date_start: this.MeetingObj.Date_start,
                          date_end: this.MeetingObj.Date_end,
                          Rm: this.MeetingObj.Rm,
                          Ref_id: this.MeetingObj.Ref_id,
                          D_meeting_id: this.MeetingObj.id,
                          create_by: this.MeData[0].perid,
                          create_time: 'now()',
                        }, this.headerAxiosPUT).then(resPut => {
                          count++
                          if (resPut.data.status) {
                            if (count == this.JoinMeet.length) {
                              this.dialogLoading = false
                              this.$swal.fire({
                                icon: 'success',
                                title: status == '1' ? 'ผู้เข้าร่วมโครงการทั้งหมดได้ทำการลงทะเบียนเข้าร่วมโครงการสำเร็จ!!' : 'ผู้เข้าร่วมโครงการทั้งหมดได้ยกเลิกการลงทะเบียนเข้าร่วมโครงการสำเร็จ!!',
                                showConfirmButton: false,
                                timer: 700
                              })
                            }
                          } else {
                            if (count == this.JoinMeet.length) {
                              this.dialogLoading = false
                              this.$swal.fire({
                                icon: 'success',
                                title: status == '1' ? 'ผู้เข้าร่วมโครงการทั้งหมดได้ทำการลงทะเบียนเข้าร่วมโครงการสำเร็จ!!' : 'ผู้เข้าร่วมโครงการทั้งหมดได้ยกเลิกการลงทะเบียนเข้าร่วมโครงการสำเร็จ!!',
                                showConfirmButton: false,
                                timer: 700
                              })
                            }
                          }
                        })
                      }
                    })
                  } else {
                    await axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/History_Experts/perid/' + item.uid + '/D_meeting_id/' + this.MeetingObj.id, {
                      active: '0',
                      update_by: this.MeData[0].perid,
                    }, this.headerAxios).then(resUpdate => {
                      count++
                      if (resUpdate.data.status) {
                        if (count == this.JoinMeet.length) {
                          this.dialogLoading = false
                          this.$swal.fire({
                            icon: 'success',
                            title: status == '1' ? 'ผู้เข้าร่วมโครงการทั้งหมดได้ทำการลงทะเบียนเข้าร่วมโครงการสำเร็จ!!' : 'ผู้เข้าร่วมโครงการทั้งหมดได้ยกเลิกการลงทะเบียนเข้าร่วมโครงการสำเร็จ!!',
                            showConfirmButton: false,
                            timer: 700
                          })
                        }
                      } else {
                        if (count == this.JoinMeet.length) {
                          this.dialogLoading = false
                          this.$swal.fire({
                            icon: 'success',
                            title: status == '1' ? 'ผู้เข้าร่วมโครงการทั้งหมดได้ทำการลงทะเบียนเข้าร่วมโครงการสำเร็จ!!' : 'ผู้เข้าร่วมโครงการทั้งหมดได้ยกเลิกการลงทะเบียนเข้าร่วมโครงการสำเร็จ!!',
                            showConfirmButton: false,
                            timer: 700
                          })
                        }
                      }
                    })
                  }
                } else {
                  count++
                  if (count == this.JoinMeet.length) {
                    this.dialogLoading = false
                    this.$swal.fire({
                      icon: 'success',
                      title: status == '1' ? 'ผู้เข้าร่วมโครงการทั้งหมดได้ทำการลงทะเบียนเข้าร่วมโครงการสำเร็จ!!' : 'ผู้เข้าร่วมโครงการทั้งหมดได้ยกเลิกการลงทะเบียนเข้าร่วมโครงการสำเร็จ!!',
                      showConfirmButton: false,
                      timer: 700
                    })
                  }
                }
              }
            })
          })
        }
      })
    },
    /*RegisterPersonRdo(item) {
      axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_meeting_join2/D_meeting_uuid/' + item.D_meeting_uuid + '/perid/' + item.perid, {
        status_reg: item.status_reg,
        update_by: this.MeData[0].perid,
      }, this.headerAxios).then(async res => {
        if (res.data.status) {
          if (item.status_reg == '1') {
            await axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/History_Experts/perid/' + item.perid + '/D_meeting_id/' + this.MeetingObj.id + '/?limit=1').then(async resHis => {
              if (resHis.data) {
                if (resHis.data.active == '0') {
                  await axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/History_Experts/id/' + resHis.data.id, {
                    active: '1',
                    update_by: this.MeData[0].perid,
                  }, this.headerAxios).then(resUpdate => {
                    if (resUpdate.data.status) {
                      this.$swal.fire({
                        icon: 'success',
                        title: 'รหัสบุคลากร ' + item.perid + ' : ' + item.full_Name + ' ลงทะเบียนเข้าร่วมประชุมสำเร็จ !!',
                        showConfirmButton: false,
                        timer: 700
                      })
                    }
                  })
                }
              } else {
                await axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/History_Experts/', {
                  perid: item.perid,
                  Project_code: '',
                  Project_name: '',
                  date_travel_start: '0000-00-00',
                  date_travel_end: '0000-00-00',
                  time_start: this.MeetingObj.Time_start,
                  time_end: this.MeetingObj.Time_end,
                  subject: this.MeetingObj.Topic,
                  type: '15',
                  date_start: this.MeetingObj.Date_start,
                  date_end: this.MeetingObj.Date_end,
                  Rm: this.MeetingObj.Rm,
                  Ref_id: this.MeetingObj.Ref_id,
                  D_meeting_id: this.MeetingObj.id,
                  create_by: this.MeData[0].perid,
                  create_time: 'now()',
                }, this.headerAxiosPUT).then(resPut => {
                  if (resPut.data.status) {
                    this.$swal.fire({
                      icon: 'success',
                      title: 'รหัสบุคลากร ' + item.perid + ' : ' + item.full_Name + ' ลงทะเบียนเข้าร่วมประชุมสำเร็จ !!',
                      showConfirmButton: false,
                      timer: 700
                    })
                  }
                })
              }
            })
          } else {
            await axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/History_Experts/perid/' + item.perid + '/D_meeting_id/' + this.MeetingObj.id, {
              active: '0',
              update_by: this.MeData[0].perid,
            }, this.headerAxios).then(resUpdate => {
              if (resUpdate.data.status) {
                this.$swal.fire({
                  icon: 'success',
                  title: 'รหัสบุคลากร ' + item.perid + ' : ' + item.full_Name + ' ยกเลิกลงทะเบียนเข้าร่วมประชุมสำเร็จ !!',
                  showConfirmButton: false,
                  timer: 700
                })
              }
            })
          }
        }
      })
    },*/
    RegisterPersonRdo(item) {
      axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_meeting_join2/D_meeting_uuid/' + item.D_meeting_uuid + '/uid/' + item.uid, {
        status_reg: item.status_reg,
        update_by: this.MeData[0].perid,
      }, this.headerAxios).then(async res => {
        if (res.data.status) {
          if (item.status_reg == '1') {
            if (parseInt(item.registerType_id) == 0) {
              await axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/History_Experts/perid/' + item.uid + '/D_meeting_id/' + this.MeetingObj.id + '/?limit=1').then(async resHis => {
                if (resHis.data) {
                  if (resHis.data.active == '0') {
                    await axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/History_Experts/id/' + resHis.data.id, {
                      active: '1',
                      update_by: this.MeData[0].perid,
                    }, this.headerAxios)
                  }
                } else {
                  await axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/History_Experts/', {
                    perid: item.uid,
                    Project_code: '',
                    Project_name: '',
                    date_travel_start: '0000-00-00',
                    date_travel_end: '0000-00-00',
                    time_start: this.MeetingObj.Time_start,
                    time_end: this.MeetingObj.Time_end,
                    subject: this.MeetingObj.Topic,
                    type: '15',
                    date_start: this.MeetingObj.Date_start,
                    date_end: this.MeetingObj.Date_end,
                    Rm: this.MeetingObj.Rm,
                    Ref_id: this.MeetingObj.Ref_id,
                    D_meeting_id: this.MeetingObj.id,
                    create_by: this.MeData[0].perid,
                    create_time: 'now()',
                  }, this.headerAxiosPUT)
                }
              })
            }
            this.$swal.fire({
              icon: 'success',
              title: 'รหัสอ้างอิง ' + item.uid + ' : ' + item.full_Name + ' ลงทะเบียนเข้าร่วมประชุมสำเร็จ !!',
              showConfirmButton: false,
              timer: 700
            })
          } else {
            if (parseInt(item.registerType_id) == 0) {
              await axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/History_Experts/perid/' + item.uid + '/D_meeting_id/' + this.MeetingObj.id, {
                active: '0',
                update_by: this.MeData[0].perid,
              }, this.headerAxios)
            }
            this.$swal.fire({
              icon: 'success',
              title: 'รหัสอ้างอิง ' + item.uid + ' : ' + item.full_Name + ' ยกเลิกลงทะเบียนเข้าร่วมประชุมสำเร็จ !!',
              showConfirmButton: false,
              timer: 700
            })
          }
        }
      })
    },
    RegisterOtherPerson(item) {
      return new Promise(resolve => {
        axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_meeting_join2/', {
          status_reg: item.status_reg,
          D_meeting_uuid: this.LinkGen,
          uid: item.uid,
          name: item.name,
          sname: item.sname,
          id_card: item.idCard,
          affiliation: item.affiliation,
          position: item.position,
          phone: item.phone,
          registerType_id: item.registerType_id,
          Create_By: this.MeData[0].perid,
          Create_Time: 'now()',
        }, this.headerAxiosPUT).then(async res => {
          if (res.data.status) {
            if (item.status_reg == '1') {
              this.$swal.fire({
                icon: 'success',
                title: 'รหัสอ้างอิง ' + item.uid + ' : ' + item.full_Name + ' ลงทะเบียนเข้าร่วมประชุมสำเร็จ !!',
                showConfirmButton: false,
                timer: 700
              })
              if (this.dialogStdReg) {
                axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtime/C_card_student/', {
                  STUDENT_ID: item.uid,
                  CARD_NO: this.card_no,
                  create_by: this.MeData[0].perid,
                  create_time: 'now()',
                }, this.headerAxiosPUT)
              }
            } else {
              this.$swal.fire({
                icon: 'success',
                title: 'รหัสอ้างอิง ' + item.uid + ' : ' + item.full_Name + ' ยกเลิกลงทะเบียนเข้าร่วมประชุมสำเร็จ !!',
                showConfirmButton: false,
                timer: 700
              })
            }
            resolve(true)
          } else {
            resolve(false)
          }
        }).catch(resCatch => {
          if (resCatch) {
            resolve(false)
          }
        })
      })
    },
    RegisterPersonID_card(item) {
      axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_meeting_join2/perid/' + item.perid, {
        status_reg: '1',
        update_by: this.MeData[0].perid,
      }, this.headerAxios).then(res => {
        if (res.data.status) {
          item.status_reg = '1'
          this.$swal.fire({
            icon: 'success',
            title: 'รหัสบุคลากร ' + item.perid + ' : ' + item.full_Name + ' ลงทะเบียนเข้าร่วมประชุมสำเร็จ !!',
            showConfirmButton: false,
            timer: 700
          })
        }
      })
    },
    checkKeyEnter2(event) {
      if (event.key == "Enter") {
        this.MeetingObj.Limit_Reg_status == '0' ? this.RegisterPerson() : this.RegisterPersonUnlock()
      }
    },
    async fetchJoinMeetData2() {
      this.JoinMeet = []
      await this.initJoinMeetingData({
        uuid: this.MeetingObj.uuid,
        permiss_check: this.MeData[0].perid
      }).then(res => {
        if (res) {
          this.JoinMeet = this.JoinMeetingData
          this.JoinMeet.map((item, idx) => {
            item.idx = idx + 1
            item.IsDb = true
            item.full_Name = item.name + ' ' + item.sname
            item.idCard = item.id_card
          })
        }
        if(this.joinTab == 0 && this.TypeRegStd == '0') {
          setTimeout(() => {
            if (this.$refs.staffSel && this.$refs.staffSel.$refs.input) {
              this.$refs.staffSel.$refs.input.focus();
            }
          }, 1000)
        } else if(this.joinTab == 1 && this.TypeRegStd == '1') {
          setTimeout(() => {
            if (this.$refs.Idstudent && this.$refs.Idstudent.$refs.input) {
              this.$refs.Idstudent.$refs.input.focus();
            }
          }, 1000)
        }
      }).catch(res => {
        if (res) {
          this.$swal.fire({
            icon: 'error',
            title: 'ไม่พบข้อมูลรายชื่อผู้เข้าร่วมประชุม',
            showConfirmButton: false,
            timer: 700
          })
          if(this.joinTab == 0) {
            setTimeout(() => {
              if (this.$refs.staffSel && this.$refs.staffSel.$refs.input) {
                this.$refs.staffSel.$refs.input.focus();
              }
            }, 1000)
          } else if(this.joinTab == 1) {
            setTimeout(() => {
              if (this.$refs.Idstudent && this.$refs.Idstudent.$refs.input) {
                this.$refs.Idstudent.$refs.input.focus();
              }
            }, 1000)
          }
          // this.$swal.fire({
          //   icon: 'error',
          //   title: 'ไม่พบข้อมูลรายชื่อผู้เข้าร่วมประชุม'
          // })
          // this.alertBarColor = 'error'
          // this.alertBarText = 'ไม่พบข้อมูลรายชื่อผู้เข้าร่วมประชุม'
          // this.alertBar = true
        }
      })
      if (this.$refs.staffSel && this.$refs.staffSel.$refs.input) {
        this.$refs.staffSel.$refs.input.focus();
      }
    },
    UniqueArraybyId(collection, keyname) {
      var output = [],
        keys = [];

      collection.map((item) => {
        var key = item[keyname];
        if (keys.indexOf(key) === -1) {
          keys.push(key);
          output.push(item);
        }
      });
      return output;
    },
  },
  mounted() {
    this.changeColor({
      color: Const.defaultColorApp
    })
    this.changeHeaderName({
      headerName: Const.defaultHeaderApp
    })
    this.changeTypeProject({
      type: null
    })
    this.initMeData().then(async res => {
      if (res) {
        await this.getIgnoreMenuPermissData({
          perid: this.MeData[0].perid,
          page_id: '5'
        })
        this.getMenuPermissData().then(res => {
          if (res) {
            if (this.MenuPermiss.length > 0 && this.MenuPermiss.filter(item => item.page_id == '5' && item.page_status == '1').length > 0) {
              this.maintain = false
              this.getPermissionData({
                perid: this.MeData[0].perid
              }).then(resAdmin => {
                if (resAdmin) {
                  this.PermissionAdmin.map((Per_i, idx) => {
                    if (Per_i.permission_id == '12000') {
                      this.getMenuPermissData().then(res => {
                        if (res) {
                          if (this.MenuPermiss.length > 0 && this.MenuPermiss.filter(item => item.page_id == '5' && item.page_status == '1').length > 0 || this.IgnoreMenuPermiss.filter(item => item.perid == this.MeData[0].perid).length > 0) {
                            this.maintain = false
                            this.initDepartData()
                            if (this.staffData.length > 0) {
                              this.staffData.map(item => {
                                item.customDetail = item.full_Name + ' รหัส (' + item.perid + ')' + ' ' + item.dep_name + ' (' + item.dep_group_name + ')'
                              })
                            } else {
                              if (this.staffData.length > 0) {
                                this.staffData.map(item => {
                                  item.customDetail = item.full_Name + ' รหัส (' + item.perid + ')' + ' ' + item.dep_name + ' (' + item.dep_group_name + ')'
                                })
                              } else {
                                this.initStaffData().then(res => {
                                  if (res) {
                                    if (this.staffData.length > 0) {
                                      this.staffData.map(item => {
                                        item.customDetail = item.full_Name + ' รหัส (' + item.perid + ')' + ' ' + item.dep_name + ' (' + item.dep_group_name + ')'
                                      })
                                    }
                                  }
                                })
                              }
                            }
                            this.init()
                          } else {
                            this.pageMessage = this.MenuPermiss.filter(item => item.page_id == '5' && item.page_message != null).length > 0 ? this.MenuPermiss.filter(item => item.page_id == '5')[0].page_message : 'ปิดปรับปรุงระบบชั่วคราว'
                            this.maintain = true
                          }
                        }
                      }).then(err => {
                        if (err) {
                          this.pageMessage = this.MenuPermiss.filter(item => item.page_id == '5' && item.page_message != null).length > 0 ? this.MenuPermiss.filter(item => item.page_id == '5')[0].page_message : 'ปิดปรับปรุงระบบชั่วคราว'
                          this.maintain = true
                        }
                      })
                      this.CheckAdmin = true
                    } else {
                      if (!this.CheckAdmin && idx == this.PermissionAdmin.length - 1) {
                        this.$router.push('/')
                      }
                    }
                  })
                } else {
                  this.getPermissionUserData({
                    perid: this.MeData[0].perid
                  }).then(resUser => {
                    if (resUser) {
                      this.Permission.map((Per_i, idx) => {
                        if (Per_i.permission_id == '12000') {
                          this.getMenuPermissData().then(res => {
                            if (res) {
                              if (this.MenuPermiss.length > 0 && this.MenuPermiss.filter(item => item.page_id == '5' && item.page_status == '1').length > 0 || this.IgnoreMenuPermiss.filter(item => item.perid == this.MeData[0].perid).length > 0) {
                                this.maintain = false
                                this.initDepartData()
                                if (this.staffData.length > 0) {
                                  this.staffData.map(item => {
                                    item.customDetail = item.full_Name + ' รหัส (' + item.perid + ')' + ' ' + item.dep_name + ' (' + item.dep_group_name + ')'
                                  })
                                } else {
                                  if (this.staffData.length > 0) {
                                    this.staffData.map(item => {
                                      item.customDetail = item.full_Name + ' รหัส (' + item.perid + ')' + ' ' + item.dep_name + ' (' + item.dep_group_name + ')'
                                    })
                                  } else {
                                    this.initStaffData().then(res => {
                                      if (res) {
                                        if (this.staffData.length > 0) {
                                          this.staffData.map(item => {
                                            item.customDetail = item.full_Name + ' รหัส (' + item.perid + ')' + ' ' + item.dep_name + ' (' + item.dep_group_name + ')'
                                          })
                                        }
                                      }
                                    })
                                  }
                                }
                                this.init()
                              } else {
                                this.pageMessage = this.MenuPermiss.filter(item => item.page_id == '5' && item.page_message != null).length > 0 ? this.MenuPermiss.filter(item => item.page_id == '5')[0].page_message : 'ปิดปรับปรุงระบบชั่วคราว'
                                this.maintain = true
                              }
                            }
                          }).then(err => {
                            if (err) {
                              this.pageMessage = this.MenuPermiss.filter(item => item.page_id == '5' && item.page_message != null).length > 0 ? this.MenuPermiss.filter(item => item.page_id == '5')[0].page_message : 'ปิดปรับปรุงระบบชั่วคราว'
                              this.maintain = true
                            }
                          })
                          this.CheckSubAdmin = true
                        } else {
                          if (!this.CheckSubAdmin && idx == this.Permission.length - 1) {
                            this.$router.push('/')
                          }
                        }
                      })
                    } else {
                      this.CheckSubAdmin = false
                      this.CheckAdmin = false
                      this.$router.push('/')
                    }
                  })
                }
              })
            } else {
              this.maintain = true
            }
          }
        }).then(err => {
          if (err) {
            this.maintain = true
          }
        })
      }
    }).catch(reason => {
      console.log('Reject = ' + reason)
    })
  }
}
</script>

<style scoped>
.v-label {
  color: black;
}

.v-card {
  border: 1px solid;
}

.v-text-field>>>input {
  color: black;
}

.v-text-field>>>label {
  color: black;
  font-weight: bold;
}

.v-text-field>>>button {
  font-size: 0.1em;
}
</style>
